{
  "common": {
    "appTitle": "Draughts MVP",
    "back": "Back",
    "exit": "Exit",
    "cancel": "Cancel",
    "close": "Close",
    "continue": "Continue",
    "copy": "Copy",
    "error": "Error",
    "loading": "Loading...",
    "retry": "Retry",
    "or": "or",
    "vs": "vs",
    "you": "You",
    "anonymous": "Anonymous",
    "send": "Send",
    "download": "Download",
    "noLimit": "No limit",
    "comingSoon": "Coming soon",
    "version": "v{{version}}",
    "enabled": "Enabled",
    "disabled": "Disabled",
    "apply": "Apply",
    "errorBoundary": "Something went wrong. Try reloading: if a new version has just shipped, the reload will pick it up.",
    "dismissNotice": "Dismiss"
  },
  "errors": {
    "loadFailed": "Couldn't load this data. Try again.",
    "network": "No internet connection. Check your network and try again.",
    "notFound": "This page doesn't exist (or no longer does)."
  },
  "senzaRete": {
    "titolo": "You are offline",
    "dati": "This page can't load its data until the connection is back.",
    "home": "Online games, tournaments and the leaderboard are unavailable. You can still play against the computer or over the board on this device."
  },
  "avvisoServizio": {
    "etichetta": "Service notice",
    "preset": {
      "riavvio": "Scheduled restart: the server will be unreachable for a few moments. Games in progress are not lost.",
      "riavvioAlle": "Scheduled restart at {{ora}}: the server will be unreachable for a few moments. Games in progress are not lost.",
      "manutenzione": "Maintenance under way: some features may be unavailable.",
      "manutenzioneAlle": "Maintenance from {{ora}}: some features may be unavailable.",
      "rallentamenti": "The server is slower than usual. We are working on it."
    }
  },
  "nav": {
    "play": "Play",
    "home": "Home",
    "arena": "Arena",
    "tournaments": "Tournaments",
    "leaderboard": "Leaderboard",
    "profile": "Profile",
    "myGames": "My Games",
    "logout": "Logout",
    "signIn": "Sign In",
    "backToLocal": "Back to Local Play",
    "backToTournaments": "Back to Tournaments",
    "backToGames": "Back to Games",
    "loginRequired": "Login required",
    "faq": "FAQ & Contact",
    "rules": "Rules",
    "editor": "Editor",
    "strumenti": "Tools"
  },
  "gara": {
    "torneoInCorso": "Tournament in progress",
    "arenaInCorso": "Arena in progress"
  },
  "strumenti": {
    "titoloFoglio": "Tools",
    "orologio": "Clock",
    "estraiApertura": "Draw opening"
  },
  "orologio": {
    "titolo": "Over-the-board clock",
    "sottotitolo": "Place the phone between the players: after moving, tap your own half",
    "tocca": "Tap to start",
    "pausa": "Pause",
    "riprendi": "Resume",
    "azzera": "Reset",
    "impostazioni": "Settings",
    "suoni": "Sounds",
    "suonoTocco": "Tap sound",
    "suonoPocoTempo": "Low-time sound",
    "tempo": "Time",
    "stessoTempo": "Same time for both",
    "scaduto": "Time out",
    "mosse": "Moves"
  },
  "apertura": {
    "sottotitolo": "Draw an official opening",
    "andataRitorno": "This opening can favour one colour: in competition it is played home and away, with the colours swapped.",
    "estrai": "Draw",
    "estraiDiNuovo": "Draw again",
    "vediTabelle": "See the full tables",
    "posizioneIniziale": "Starting position"
  },
  "editor": {
    "title": "Editor",
    "subtitle": "Compose a position to study, analyze, or play",
    "boardLabel": "Editable board",
    "sideToMove": "Side to move",
    "reset": "Reset",
    "clear": "Clear",
    "flip": "Flip",
    "playPosition": "Play position",
    "playAI": "Play vs Computer",
    "challenge": "Challenge a friend",
    "challengeNote": "The game starts from your composed position and is always casual (unrated).",
    "tools": {
      "label": "Pieces",
      "whiteMan": "White man",
      "whiteKing": "White king",
      "blackMan": "Black man",
      "blackKing": "Black king",
      "erase": "Erase",
      "cycle": "Cycle piece"
    },
    "library": {
      "open": "Saved positions",
      "title": "Saved positions",
      "nameLabel": "Name",
      "namePlaceholder": "Position name",
      "defaultName": "Position",
      "defaultNameAnalysis": "Analysis",
      "save": "Save",
      "overwrite": "Overwrite",
      "willOverwrite": "“{{name}}” will be replaced.",
      "saved": "In your library",
      "empty": "No saved positions yet. Compose a position and save it here.",
      "load": "Load {{name}}",
      "lineBadge_one": "{{count}} move",
      "lineBadge_other": "{{count}} moves",
      "askLoad": "Load “{{name}}”? The position on the board will be replaced.",
      "askLoadLine": "Load “{{name}}”? The position and the line you are playing will be replaced.",
      "confirmLoad": "Load",
      "rename": "Rename {{name}}",
      "share": "Share {{name}}",
      "shareCopied": "Link copied",
      "shareTitle": "Draughts position",
      "shareText": "Take a look at this draughts position",
      "delete": "Delete {{name}}",
      "askDelete": "Delete “{{name}}”?",
      "confirmDelete": "Delete",
      "errors": {
        "nameTaken": "A position with this name already exists.",
        "full": "Library full: delete a position to save another one.",
        "saveFailed": "Could not save. Try again.",
        "deleteFailed": "Could not delete. Try again.",
        "loadFailed": "This position could not be read.",
        "loadListFailed": "Could not load your library.",
        "shareFailed": "Could not copy the link."
      }
    },
    "fen": {
      "label": "Position (FEN)",
      "copy": "Copy FEN",
      "copied": "Copied",
      "invalid": "Invalid FEN."
    },
    "analysis": {
      "title": "Analysis",
      "hint": "Move both colours. Step back and play a different move to change the line.",
      "save": "Save analysis",
      "run": "Analyze",
      "depth": "Depth",
      "fast": "Fast",
      "standard": "Standard",
      "deep": "Deep",
      "evaluation": "Evaluation",
      "cancel": "Cancel",
      "reached": "Depth reached"
    },
    "invalid": {
      "noWhite": "Add at least one white piece.",
      "noBlack": "Add at least one black piece.",
      "manOnPromotionRow": "A man can't sit on its promotion row — make it a king or move it.",
      "tooManyPieces": "Too many pieces for this variant.",
      "sideToMoveNoMoves": "The side to move has no legal moves.",
      "alreadyTerminal": "This position is already decided (won or drawn).",
      "offBoard": "A piece is on a square this variant does not have.",
      "duplicateSquare": "Two pieces on the same square."
    }
  },
  "rules": {
    "channels": {
      "cta": "Recommended channels",
      "title": "Recommended channels",
      "note": "Channels we recommend for watching and studying this variant.",
      "opensOnYouTube": "Opens on YouTube"
    },
    "backToRules": "All rules",
    "playOnline": "Play now",
    "playAI": "Play vs computer",
    "indexTitle": "Draughts Rules",
    "indexIntro": "Two rule books in one place: the rules of play for every variant we support, and the rules our online tournaments run by.",
    "gameTitle": "Draughts Rules by Variant",
    "gameIntro": "Draughts — also known as checkers, dama, dammen and damas — is played all over the world, each region with its own rules. Browse the rules of every variant we support below.",
    "gameCtaDesc": "Board, movement, capture and promotion — variant by variant.",
    "heroSubtitle": "Rules, board setup and how to play {{variant}}.",
    "startingPosition": "Starting position",
    "howToPlay": "How to play",
    "otherVariants": "Other variants",
    "eyebrow": "Rules",
    "glance": {
      "title": "At a glance",
      "board": "Board",
      "pieces": "Pieces per side",
      "starts": "First move"
    },
    "theme": {
      "movement": "Movement",
      "capture": "Captures",
      "promotion": "Promotion"
    },
    "variantsLabel": "Variants",
    "draughtsWord": "draughts",
    "tournaments": {
      "title": "Tournament rules",
      "heroSubtitle": "Everything a tournament settles on its own, from the number of rounds to the tiebreaks.",
      "intro": "Once it starts, a tournament runs itself: it counts the players present, picks the pairing system, fixes the number of rounds and ranks the field. These are the rules it applies, in the order it applies them.",
      "source": "Source: FIDE C.04.1 and FMJD Annex 3, adapted to online play.",
      "cta": "How a tournament works",
      "ctaDesc": "Format, rounds, entry, absences, tiebreaks and the arena.",
      "chaptersLabel": "Chapters",
      "format": {
        "title": "Format",
        "body": [
          "One round-based format only, the round-robin/Swiss: whoever opens a tournament does not choose between a round robin and the Swiss system, they choose an entry threshold. Alongside tournaments there is the arena, which is a different thing: see the chapter “The arena”.",
          "At starting time the players who actually signed up are counted. Below the threshold the tournament is a round robin: everybody plays everybody, using the Berger tables. From the threshold up it is a Swiss system: each round pairs you with players on your own score, and you never face the same opponent twice.",
          "The default threshold is 7 and can be set between 7 and 20; a round robin takes at most 19 players.",
          "The reason is simple: when a tournament is created nobody knows how many will show up, and picking the format in advance means picking it blind.",
          "A win is 2 points, a draw 1 point, a loss none. With an odd number of players one of them sits out each round, and what that bye is worth depends on the format: in a Swiss it is worth 2 points, like a win — 4 in a two-leg tournament, where every round is two games — while in a round robin it is worth nothing, because there everyone meets everyone and the bye is only a round that is not played. In neither case does it count as a game won, and in neither does it enter the tiebreaks."
        ]
      },
      "rounds": {
        "title": "Number of rounds",
        "body": [
          "The number is fixed when the tournament starts, from the players actually present. With the default threshold, by number of players:",
          "A tournament takes at most 200 players, so ten rounds is the longest one can get — eleven with the extra round.",
          "In a round robin the rounds are however many it takes for everyone to meet everyone else. With three or four players both legs are always played, whatever the organiser chose: every round becomes two games, because with only one game per opponent a first-round loss would already decide the tournament. Four players means three rounds and six games each; three players play the same three rounds but one sits out each time, so everybody rests once and plays four games — and the rest is worth no points.",
          "In a Swiss, doubling the field adds one round: every round halves the number of players who can still finish on a perfect score. It is one round more than a knockout would need, because otherwise two players could end up level at the top without ever having met.",
          "Two switches change the count. «Extra round» adds one to the table when the field can carry it, and it only applies if the start produces a Swiss: in a round robin everybody already meets everybody, and one more round would just be a rematch for all. «Two legs», instead, does not add rounds — it fills them: every pairing is played twice in a row, colours reversed and on the same opening, inside the same round, which therefore lasts twice as long. It works the same way in a round robin and in a Swiss, and points stay per game: a win and a draw make 3, two wins make 4."
        ],
        "rounds": [
          "3-4 — round robin, 3 rounds",
          "5-6 — round robin, 5 rounds",
          "7-8 — Swiss, 4 rounds",
          "9-16 — Swiss, 5 rounds",
          "17-32 — Swiss, 6 rounds",
          "33-64 — Swiss, 7 rounds",
          "65-128 — Swiss, 8 rounds",
          "129-192 — Swiss, 9 rounds",
          "193-200 — Swiss, 10 rounds"
        ]
      },
      "entry": {
        "title": "Entry and withdrawal",
        "body": [
          "Anyone with a registered account can open one: no permission is needed and there is no official organiser. Guests and computers do not enter tournaments, neither to open them nor to play them.",
          "Three live competitions per person: you can keep up to three tournaments or arenas open at once, and to open another you must wait for one to finish, or cancel it.",
          "A tournament is scheduled, not started by hand: the start time is set between five minutes and fourteen days ahead. Whoever opens it only organises it: to play they must press «Join» on the tournament page like everybody else, and until they do they do not count towards the field — a minimum of 3 means three people besides them.",
          "Seats run from 3 to 200. The minimum to start is 3, and the organiser can raise it: if at starting time there are fewer players than the minimum, the tournament cancels itself. Until it has started the organiser can cancel it; afterwards not, because those already playing are entitled to finish.",
          "A tournament can be private: you get in only with the password the organiser chose, or with the invitation link.",
          "You can sign up until the first round begins, and until then you can also withdraw — cancelling before the start removes you from the standings at once, because you have not played anything yet. From there the door closes both ways: whoever is in stays in the draw, because withdrawing halfway would leave an opponent without a game every remaining round."
        ]
      },
      "absences": {
        "title": "Absences",
        "body": [
          "It depends on where you were, and the three cases end in three different ways.",
          "If you are simply offline, the game opens anyway and your clock starts. Arriving three minutes late means playing with three minutes less, not losing the game: only if you never arrive do you lose on time. A game one of the two never sat down to does not move either player's rating.",
          "The same applies if you connect and your connection drops before your first move: your clock decides. After your first move, if you drop, you have 30 seconds to come back, as in any game.",
          "If instead you are already busy in another game — an arena, a challenge, another tournament — the round's game does not open at all and you take a walkover loss, with the 2 points going to your opponent. It is not a punishment: opening a second board for you would make the one you are already playing unreachable.",
          "If both of you are missing, the round closes 0-0 and nobody gets anything. An official draw would reward the absence.",
          "In none of the three cases are you thrown out: the next round pairs you as usual.",
          "One last thing applies to everyone: a tournament has an announced duration, and if games are still running at that time they get ten minutes. After that the tournament closes and the games still open are ruled draws."
        ]
      },
      "openingMoves": {
        "title": "Opening moves",
        "body": [
          "It depends on how the tournament was opened, and there are nine ways.",
          "«Free move» is the normal one: you play from the first move, and nothing is imposed.",
          "Then come the draws. Three of them place one, two or three random legal moves, and work on every variant. Another four draw from an official F.I.D. table, and exist only on Italian and English, the two variants that have a federal table: what you choose there is how lopsided the opening that comes out may be — up to 1N/1B, up to 2N/2B, up to 3N/3B, or all 174 of them. In a Swiss the same opening never comes out twice in the same tournament.",
          "And then there is the themed tournament: the organiser picks ONE of the 174 official openings, and everybody plays it, in every round and every game. It is the only case where the opening is known before play starts, and the only one where the «never the same twice» rule does not apply — that would be the exact opposite of what a themed tournament asks for.",
          "With two legs the two games of a round are played on the same opening with colours reversed: that is how a lopsided opening stops favouring anyone."
        ]
      },
      "rated": {
        "title": "Rated tournaments",
        "body": [
          "If the tournament is rated, yes — and not in a separate table: tournament games move the same rating as every other game, the one for the variant and the time control being played. The organiser decides, and by default it is rated.",
          "A rated tournament or arena may have a rating floor, that is a minimum rating to get in, in steps from 1000 up to 2000: it is measured on your rating for that variant and that time control, not on a general one. Casual ones have no floor, because the rating does not move and there is nothing to protect. There is no ceiling: nobody is kept out for being too strong.",
          "There is then one thing that can switch the rating off by itself, and that is the opening. The federal rule says a single game is enough as long as the opening goes up to 2N/2B; beyond that one colour's advantage is too large for one game to compensate, and two legs are needed. It works both ways: on a draw what counts is the ceiling of the table being drawn from, on a themed tournament what counts is the strength of the chosen opening, which there is known already. If the combination does not hold, the tournament is created casual instead of being refused — and turning two legs on makes it rated again.",
          "Finally, games one of the two never sat down to are not rated."
        ]
      },
      "tiebreaks": {
        "title": "Tiebreaks",
        "body": [
          "It depends on the format.",
          "In the Swiss system, in this order:",
          "1. Buchholz Cut 1: the sum of the final scores of every opponent faced, minus the weakest one. It rewards whoever had the harder path. A bye is not counted, because it is not an opponent.",
          "2. Sonneborn-Berger: the scores of the opponents you beat, plus half the scores of those you drew with. It rewards whoever beat the stronger players.",
          "3. The number of wins.",
          "4. The rating change in the tournament: how many rating points you gained or lost in this tournament's games. It rewards whoever did better than expected, not whoever was already stronger. Players still level after this share the place.",
          "In the standings Buchholz and Sonneborn-Berger come after wins, draws, losses and byes, shortened to BH and SB.",
          "In a round robin the tiebreaks are different, because everybody plays everybody and Buchholz would separate nobody: first the number of wins, then the result of the direct encounter among the players on the same score, then Sonneborn-Berger (SB), and finally the rating change in the tournament. If they are still level, the better place in the schedule goes ahead, which means the higher rating at the start of the tournament: a round robin has no shared places. BH is not shown there, because when everybody plays everybody it is only the mirror image of the points. In the standings «H2H» marks whoever is ahead on head-to-head.",
          "An arena has no rounds, so Buchholz could not be computed: on equal points the order is decided by the number of wins, then the head-to-head among players on equal points, then the average points of the opponents faced — the average and not the sum, because in an arena people play very different numbers of games — and finally who reached the same points in fewer games. In the standings the two numbers appear only on the rows that are level, where they are needed: \"H2H\" is the head-to-head, \"Opponents\" their average."
        ]
      },
      "sharedPlaces": {
        "title": "Shared places",
        "body": [
          "In a Swiss it happens in small tournaments when every game ends in a draw: same points, same Buchholz, same Sonneborn-Berger, no wins for anyone.",
          "In that case the place is shared. Two players tied for first both take gold, and the next place is third: 1, 1, 3, as in any sports table. Nobody is pushed ahead of anybody else because of their rating or because they signed up earlier.",
          "One caveat: the tournament record keeps a single name as the winner, because that field holds one. The standings and the podium show everyone who tied."
        ]
      },
      "arena": {
        "title": "The arena",
        "body": [
          "The other competition you can open, and it is not a round-based tournament: it has neither rounds nor a schedule, it has a duration. It opens, it runs from ten minutes to eight hours, and while it is open you are paired again as soon as you finish, without waiting for anyone else to finish theirs. You come and go as you like, even once it has started.",
          "With the same person, though, you wait: five minutes for every game already played together. The first rematch comes after five minutes, the second after ten, the third after fifteen, and there is no cap. It keeps an arena from turning into the same match over and over.",
          "Scoring: a win 2, a draw 1, a loss none, as in a tournament.",
          "And there is the boost, taken before your own first move: it doubles the points of a win and is paid with the clock — the increment goes entirely, and the base time is halved. It is a bet, not a gift.",
          "On equal points the order is decided, in sequence, by: who won more games; then the head-to-head among players level on both points and wins; then the strength of the opponents faced, meaning the average of their points — the average and not the sum, because in an arena people play very different numbers of games and a sum would only reward whoever plays the most; and finally who reached the same points in fewer games. Interrupted games do not count, and players level on the last criterion share the place: an arena can have two winners."
        ]
      }
    },
    "seo": {
      "title": "{{variant}} Rules — How to Play",
      "description": "Learn the rules of {{variant}}: board size, starting position, how pieces and kings move and capture, and how to win. Play {{draughtsWord}} online for free.",
      "indexTitle": "Draughts Rules — Game Rules and Tournament Rules",
      "indexDescription": "Two rule sets for {{draughtsWord}}: the rules of play for every variant — International, Italian, Turkish, Frisian and more — and the rules of our online tournaments.",
      "gameTitle": "Draughts Rules by Variant — How to Play",
      "gameDescription": "Rules and how-to-play guides for every {{draughtsWord}} variant: International, Italian, Turkish, Frisian, Brazilian and many more. Play online for free.",
      "openingsTitle": "{{variant}}: official F.I.D. opening tables",
      "openingsDescription": "All 174 official {{variant}} openings with their strength code and federal tables A, B, C and D. F.I.D. Regolamento Tecnico 2025.",
      "captureTitle": "{{variant}}: the complete capture rules",
      "captureDescription": "Every capture rule of {{variant}}: when capturing is compulsory, multi-captures, the precedence that decides which capture you must play, and promotion. With board examples.",
      "tournamentsTitle": "Tournament rules — how a {{draughtsWord}} tournament works",
      "tournamentsDescription": "The rules of online {{draughtsWord}} tournaments: round-robin/Swiss format, number of rounds, entry and withdrawal, absences, the opening draw, rating, tiebreaks and the arena."
    },
    "fact": {
      "board": "Played on a {{size}}×{{size}} board, on the dark squares only.",
      "boardAllSquares": "Played on a {{size}}×{{size}} board, using all squares.",
      "pieces": "Each player starts with {{count}} pieces.",
      "startsWhite": "White moves first.",
      "startsBlack": "Black moves first.",
      "moveDiagonal": "Men move diagonally forward, one square at a time.",
      "moveOrthogonal": "Men move orthogonally — forward and sideways — one square at a time.",
      "captureDiagonal": "Captures are made diagonally, jumping over an adjacent opponent's piece.",
      "captureOrthogonal": "Captures are made orthogonally, jumping over an adjacent opponent's piece.",
      "captureMixed": "Captures can be made both diagonally and orthogonally.",
      "menCaptureBackwardYes": "Men may capture both forward and backward.",
      "menCaptureBackwardNo": "Men may capture forward only.",
      "kingFlying": "Kings are \"flying\": they move and capture across any number of empty squares along a line.",
      "kingShort": "Kings move one square at a time (no flying kings).",
      "menCaptureKingYes": "Men are allowed to capture kings.",
      "menCaptureKingNo": "Men cannot capture kings.",
      "maxCapturePieces": "Capturing is mandatory, and you must take the sequence that captures the most pieces.",
      "maxCaptureValue": "Capturing is mandatory and you must take the sequence of greatest value: a king is worth more than a man, but two men are worth more than a king.",
      "captureMandatoryFree": "Capturing is mandatory, but you may freely choose which capture to make.",
      "kingPriorityTie": "When the captures are otherwise equal, you must capture with a king, not with a man.",
      "maxKingsCaptureTie": "When the piece count is equal, you must take the sequence that captures the most kings.",
      "firstKingFirst": "Still equal, you must take the sequence in which the king or kings come first.",
      "huffing": "The \"huffing\" rule applies: a piece that failed to capture may be removed.",
      "captureImmediateRemoval": "Each captured piece is removed from the board immediately, which can open up further captures in the same sequence.",
      "captureNoReversal": "Within a multi-capture you may continue straight or turn 90°, but never reverse 180° between two jumps.",
      "promotionStops": "A man reaching the last row is promoted and the move ends, even mid-capture.",
      "promotionContinues": "A man that crosses the last row mid-capture stays a man and keeps capturing; it promotes only if the move ends on the last row.",
      "promotionInPassing": "A man that reaches the last row mid-capture is promoted at once and continues the capture as a flying king in the same turn.",
      "blockedKing": "While a player still has men, they may not make more than {{n}} consecutive simple moves with the same king; the restricted king may still capture.",
      "frisianEndgame": "Frisian endgame draw rules apply (e.g. two kings versus one is drawn after a set number of moves).",
      "loneKingWins": "If a player is left with a single man against the opponent's lone king, the king's side is declared the winner.",
      "singlePieceLoses": "A player left with a single piece — man or king — immediately loses the game.",
      "drawLimit": "The game is drawn after {{n}} moves in which only kings move and nothing is captured."
    },
    "openings": {
      "title": "Opening tables",
      "heroSubtitle": "The 174 official {{variant}} openings, with their strength code and the federal table they belong to.",
      "source": "Source: Regolamento Tecnico F.I.D., January 2025.",
      "cta": "Opening tables",
      "ctaDesc": "The 174 official openings and how they are rated.",
      "intro": "In official play the first three half-moves are not chosen but drawn from a table. The general table holds all 174 openings; the federal tables A, B, C and D are subsets of it, used depending on the kind of match.",
      "ratedNote": "In a direct challenge you can cap the draw by strength: up to 2N/2B a single game still counts for the rating, above that you need a two-game match.",
      "tableAll": "General",
      "tableA": "Table A",
      "tableB": "Table B",
      "tableC": "Table C",
      "tableD": "Table D",
      "count": "{{count}} openings",
      "colNumber": "No.",
      "colOpening": "Opening",
      "colStrength": "Strength",
      "colStrengthShort": "Str.",
      "colTables": "Tables",
      "colTablesShort": "Tab.",
      "firstMove": "First move {{move}}",
      "legendTitle": "How to read the strength code",
      "legendColours": "N = Black (Nero), B = White (Bianco).",
      "legendPari": "PARI — even game.",
      "legend1": "1N / 1B — that colour is slightly better, with more choice of lines.",
      "legend2": "2N / 2B — that colour is clearly better and the opponent plays defensively.",
      "legend3": "3N / 3B — that colour is formidable: the opponent needs expert play to draw.",
      "legend4": "4N / 4B — that colour is considered winning with current knowledge.",
      "tablesTitle": "The federal tables",
      "italianA": "Two-game matches, pairs and team events only.",
      "italianB": "Default table of official events; also usable in a single game.",
      "italianC": "Subset of B for youth and provincial categories and promotional tournaments.",
      "italianD": "The openings considered winning: two-game matches only.",
      "englishA": "The table normally used in two-game matches and team events.",
      "englishB": "Tournaments played over a single game.",
      "englishC": "Subset of B for the special cases the event rules allow.",
      "englishD": "The openings considered winning: two-game matches only.",
      "tableEvery": "Every",
      "everyTitle": "Why 302 openings become 174",
      "everyIntro": "There are {{total}} legal three-half-move openings, but they only reach {{positions}} different positions: the general table picks {{listed}} of them, one per position. Here is what happens to the rest.",
      "status_ballot": "Listed",
      "statusBallotDesc": "Drawable: one of the official openings.",
      "statusTransposition": "Same as no. {{id}}",
      "statusTranspositionShort": "Transposition",
      "statusTranspositionDesc": "Same final position as an opening already listed, reached by playing the moves in another order: it would be the same game under a different name.",
      "status_material": "Loses a man",
      "statusMaterialDesc": "After the third half-move one side is a man down with no recapture: these are the two combinations the regulation has always excluded.",
      "status_unlisted": "Not listed",
      "statusUnlistedDesc": "A position the table does not cover at all. There is no mechanical reason: the federation selected the lines worth studying.",
      "statusDecidedDesc": "Still listed, but for two-game matches only: they are considered winning for the favoured colour, and therefore losing for the other.",
      "colPosition": "Position"
    },
    "capture": {
      "cta": "The capture rules",
      "ctaDesc": "The capture precedence, step by step, with examples.",
      "title": "Capture rules",
      "heroSubtitle": "When capturing is compulsory, which capture you must play, and how it is counted, in {{variant}}.",
      "intro": "Capturing is the most tightly regulated part of the game. Knowing how to capture is not enough: you need to know which capture you are obliged to play. Every rule is here, in the exact order the game applies it.",
      "source": "Source: F.I.D. Technical Regulations, January 2025.",
      "mandatoryTitle": "Capturing is compulsory",
      "mandatoryBody": "If a capture exists on your turn, every quiet move disappears: they are not bad moves, they simply do not exist. The obligation applies to the whole position, not to a single piece.",
      "mandatoryRejected": "There is no penalty for getting it wrong: a capture that breaks the rules is rejected and the position stays as it was.",
      "geometryTitle": "How a capture works",
      "geometryShortKing": "A king also jumps a single square: the opponent's piece must be immediately next to it on the diagonal.",
      "geometryLanding": "The square behind the captured piece must be empty. If it is occupied, by any piece at all, or off the board, that capture does not exist.",
      "menVsKingTitle": "Men and kings",
      "menVsKingWall": "To a man, an opponent's king is a wall: it can neither be captured nor jumped over. A king placed in front of a group of pieces puts them out of reach of every man.",
      "menVsKingFree": "There is no restriction by rank: any piece may capture any piece.",
      "multiTitle": "The multi-capture",
      "multiBody": "If after a jump the piece faces another capturable piece, it must carry on. Stopping halfway is not a choice: an incomplete sequence is not a legal move.",
      "multiDirection": "You may change direction at every jump. A man, however, only alternates between its two forward diagonals: it never gains a backward capture during the sequence.",
      "multiNoTwice": "No opponent's piece can be jumped twice in one sequence. The same empty square, on the other hand, may be crossed as often as needed.",
      "ladderTitle": "Capture precedence",
      "ladderIntro": "When more than one capture is available, the choice is not yours. The game compares them by these criteria, in this order: it only moves to the next criterion when the previous one leaves several captures tied.",
      "ladderWholePosition": "The comparison spans every capture by every one of your pieces. A piece can therefore be stuck because another piece has a better capture.",
      "ladderNoneIntro": "Capturing is compulsory, but which capture to play is entirely up to you. There is no precedence at all: a single capture counts as much as a multi-capture, and nothing forces you to take more.",
      "levelLabel": "Level {{n}}",
      "levelMaxPieces": "You must play the capture that takes the greatest number of pieces.",
      "whyMaxPieces": "Pieces are counted, not their value: two men beat one king.",
      "levelMaxValue": "You must play the capture with the highest total value.",
      "whyMaxValue": "Kings weigh more than men, so the longest sequence does not always win.",
      "levelWithKing": "With the piece count equal, you must capture with a king, not with a man.",
      "whyWithKing": "The criterion is about the capturing piece, not the captured one. If a king and a man take the same number of pieces, the king must move, even when the man would take more valuable pieces.",
      "levelMaxKings": "Still equal, you must play the capture that takes the greatest number of kings.",
      "whyMaxKings": "Here what matters is the value of what you remove. Since only kings can capture kings, this criterion only ever separates captures made by a king.",
      "levelFirstKing": "Still equal, you must take the sequence in which the king or kings come first.",
      "whyFirstKing": "It looks at the order of the jumps: the route that meets its first king on the earlier jump wins; if that is level, the second king decides, then the third. The choice is free only when the kings fall on the same jumps.",
      "levelFree": "If the captures remain equivalent, the choice is free.",
      "whyFree": "Beyond this point no rule binds the player: two captures identical on every criterion may be played interchangeably.",
      "removalTitle": "When the pieces come off",
      "removalEnd": "Captured pieces stay on the board until the move ends and are taken off together once the sequence is complete. That is why you still see them in place during a multi-capture.",
      "removalImmediate": "The vacated square becomes available at once. Jumping the same piece twice remains forbidden.",
      "promotionTitle": "Promotion ends the capture",
      "promotionBody": "If a man reaches the last row during a sequence, the move ends there: the man becomes a king and the turn passes, even if further jumps would be available from that square. The new king moves from the following turn.",
      "promotionNoExemption": "Promotion grants no exemption from precedence: the interrupted sequence is compared on the pieces it actually took. If another capture takes more, the promoting one is illegal.",
      "promotionStillAMan": "For precedence, a man that promotes still counts as a man: it does not gain a king's priority.",
      "noHuffingTitle": "No huffing",
      "noHuffingBody": "The \"huffing\" rule does not apply: a player who misses a compulsory capture does not lose the piece, they simply cannot play that move.",
      "exGeometry": "White jumps the adjacent piece and lands immediately behind it.",
      "exMenVsKingWall": "The man stands next to an opponent's king and cannot take it: only a quiet move is left.",
      "exMenVsKingFree": "Here the man captures the king just as it would any other piece.",
      "exMulti": "One legal move only: the sequence must be played to the end.",
      "exPromotion": "White reaches the last row, so the move ends there — even with a piece still to take.",
      "exMaxPieces": "Two captures available: one takes a single piece, the other takes two. Only the longer one is legal.",
      "exMaxValue": "Among the available captures, the total value of the pieces taken decides.",
      "exWithKing": "The king and the man each take one piece: the king is the one that must move.",
      "exMaxKings": "Two kings can capture: the opponent's king must be taken, not the man.",
      "exFirstKing": "Two routes of two pieces with one king each: the one taking the king first is compulsory.",
      "exFree": "The first jump is forced, then the capture forks: two pieces either way, and the choice is yours.",
      "exFreeNoLadder": "One capture takes a single piece, the other takes two: here both are legal.",
      "forced": "Compulsory move",
      "choices": "Legal moves",
      "diagramAlt": "Example position"
    },
    "gameRulesHead": "Game rules"
  },
  "faq": {
    "title": "FAQ & Contact",
    "intro": "Frequently asked questions and a direct channel for issues, requests, and feedback.",
    "questionsTitle": "Frequently asked questions",
    "entries": [
      {
        "id": "install-android",
        "q": "How do I install the app on Android?",
        "a": "The app installs straight from the browser — no Play Store needed.\n1. Open the site in Chrome (or Edge, Samsung Internet).\n2. Tap the ⋮ menu at the top right.\n3. Choose \"Install app\" (or \"Add to Home screen\") and confirm.\nSome browsers also show an install banner on their own — you can use that instead. The icon then appears with your other apps and the game opens full screen, without the browser bar."
      },
      {
        "id": "install-ios",
        "q": "How do I install the app on iPhone or iPad?",
        "a": "On iPhone and iPad the steps are different and have to be done in Safari.\n1. Open the site in Safari (in other browsers the option may not appear).\n2. Tap the Share button (the square with an arrow pointing up): at the bottom on iPhone, at the top on iPad.\n3. Scroll the list and choose \"Add to Home Screen\".\n4. Tap \"Add\" at the top right.\niOS never shows an automatic install prompt, so without these steps no icon is created."
      },
      {
        "id": "install-desktop",
        "q": "Can I install the app on my computer?",
        "a": "Yes, with Chrome or Edge.\n1. Open the site.\n2. Click the install icon on the right-hand side of the address bar, or open the browser menu and choose \"Install…\".\n3. Confirm: the app opens in its own window, without the browser bar.\nFirefox and Safari on desktop don't support installing web apps — you can still play normally in the browser and bookmark the site."
      },
      {
        "id": "login",
        "q": "I can't sign in to my account — what should I do?",
        "a": "Make sure your email and password are correct. If you forgot your password, use the \"Forgot password\" link on the sign-in screen. If the problem persists, fill in the contact form below and select the \"Login problem\" category."
      },
      {
        "id": "verify-email",
        "q": "I never received the verification email — how do I get it again?",
        "a": "Open the sign-in dialog, try to log in with your credentials, then click the \"Resend verification email\" button. Don't forget to check your spam folder."
      },
      {
        "id": "variant-request",
        "q": "Can I suggest a new draughts variant?",
        "a": "Yes! Fill in the contact form below, select \"New variant request\", and describe the rules of the variant you'd like us to support."
      },
      {
        "id": "rules-wrong",
        "q": "The rules of a variant look wrong — how do I report it?",
        "a": "Fill in the contact form below and select \"Rules correction\". Tell us which variant is affected and describe the rule that needs to be fixed, ideally with a link to the official source (FMJD, FID, WCDF, etc.)."
      },
      {
        "id": "delete-account",
        "q": "How do I delete my account?",
        "a": "Open your profile settings: you'll find options to export your data (GDPR) and to permanently delete your account. Deletion is irreversible."
      }
    ],
    "contactTitle": "Contact us",
    "contactIntro": "Couldn't find your answer? Write to us and we'll reply by email.",
    "category": {
      "login": "Login problem",
      "variant_request": "New variant request",
      "rules": "Rules correction",
      "other": "Other"
    },
    "fields": {
      "name": "Name (optional)",
      "email": "Email",
      "category": "Category",
      "subject": "Subject",
      "message": "Message"
    },
    "submit": "Send request",
    "success": "Thanks! Your request has been sent. We'll get back to you by email as soon as possible.",
    "errors": {
      "invalidEmail": "Please enter a valid email address.",
      "subjectTooShort": "Subject must be at least 3 characters.",
      "messageTooShort": "Message must be at least 10 characters.",
      "rateLimited": "You've sent too many requests recently. Please try again in an hour.",
      "submitFailed": "Sending failed. Check your connection and try again."
    }
  },
  "home": {
    "heroTitle": "Draughts Online",
    "heroTagline": "The international, Italian, and English draughts platform. Play, compete in tournaments and climb the leaderboard.",
    "welcome": "Welcome",
    "newGame": "New Game",
    "chooseMode": "Choose your game mode",
    "startNow": "Play",
    "vsAI": "Play vs AI",
    "vsAIDesc": "Practice against the computer",
    "vsOnline": "Play Online",
    "vsOnlineDesc": "Challenge real players",
    "vsFriends": "Play with Friends",
    "vsFriendsDesc": "Create or join a private game",
    "createTable": "Create Table",
    "createTableDesc": "Invite a friend to play",
    "joinTable": "Join Table",
    "joinTableDesc": "Enter a room code",
    "enterRoomCode": "Enter the room code shared by your friend",
    "variant": "Variant",
    "difficulty": "Difficulty",
    "timeControl": "Time Control",
    "startGame": "Start Game",
    "playersOnline": "players online",
    "gamesInProgress": "games in progress",
    "landing": {
      "heroTitle": "Play Draughts",
      "heroTitleAccent": "Online",
      "heroTagline": "Draughts variants from around the world. Tournaments, rated games, AI opponents — play now.",
      "playFree": "Play Now",
      "signUp": "Sign up",
      "playAsGuest": "Play as Guest",
      "featuresLabel": "Why Draughts?",
      "featuresTitle": "Everything you need to play",
      "featuresSubtitle": "A complete platform built for competitive and casual draughts players alike.",
      "featureTournaments": "Tournaments",
      "featureTournamentsDesc": "Swiss and Arena formats with automatic pairing, Glicko-2 ratings, and real-time leaderboards.",
      "featureRating": "Rating System",
      "featureRatingDesc": "Separate Glicko-2 ratings across variants and time controls. Track your progress over time.",
      "featureAI": "AI Opponents",
      "featureAIDesc": "6 difficulty levels from beginner to expert. Practice anytime, no waiting for opponents.",
      "featureVariants": "World Variants",
      "featureVariantsDesc": "From International and Italian to Turkish, Frisian and more — draughts variants from around the world.",
      "featureOnline": "Online Play",
      "featureOnlineDesc": "Find an opponent in seconds with matchmaking and play rated or casual games.",
      "featurePuzzles": "Daily Puzzles",
      "featurePuzzlesDesc": "A new puzzle every day across several variants. Sharpen your tactics and grow your rating.",
      "specBoard": "{{size}} Board",
      "specPieces": "{{count}} pieces per side",
      "specFlyingKings": "Flying kings",
      "specShortKings": "Short-range kings",
      "howLabel": "How?",
      "howTitle": "Start playing in seconds",
      "step1Title": "Create an Account",
      "step1Desc": "Sign up in seconds. Or play instantly as a guest.",
      "step2Title": "Choose Your Game",
      "step2Desc": "Pick variant, time control, and play against people or AI.",
      "step3Title": "Climb the Ranks",
      "step3Desc": "Win games, earn rating points, and compete in daily tournaments.",
      "variantsLabel": "Game Variants",
      "variantsTitle": "Every variant of draughts, one platform",
      "variantsMoreTitle": "And many more variants",
      "variantsAllCta": "See the rules of every variant",
      "intlBadge": "FMJD Official",
      "intlDesc": "The standard for competitive draughts worldwide. Flying kings, mandatory captures, and longest capture rule.",
      "italianBadge": "Traditional",
      "italianDesc": "The beloved Italian tradition. Men cannot capture kings, and the most-pieces-captured rule creates deep tactical play.",
      "englishBadge": "WCDF Official",
      "englishDesc": "Classic 8×8 draughts played worldwide. Mandatory capture, non-flying kings, men can capture kings, and no backward movement for men.",
      "brazilianBadge": "Popular",
      "brazilianDesc": "Brazil's favorite draughts variant. 8×8 board with flying kings, mandatory longest capture, and men can capture backwards.",
      "ctaTitle": "Ready to play?",
      "ctaSubtitle": "Join the community. Start your first game.",
      "ctaButton": "Start Playing Now",
      "heroCta": "Play now",
      "puzzleTitle": "Try a puzzle",
      "puzzleSubtitle": "Solve this position right now — no sign-up needed. Then create a free account to play the daily puzzle and grow your rating."
    },
    "dashboard": {
      "welcomeBack": "Welcome back",
      "recentGames": "Recent Games",
      "viewAll": "View All",
      "liveUpcoming": "Live & Upcoming",
      "allTournaments": "All Tournaments",
      "thisWeek": "this week",
      "live": "LIVE",
      "join": "Join",
      "noRecentGames": "No games yet. Play your first game!",
      "noTournaments": "No upcoming tournaments.",
      "dailyPuzzle": {
        "title": "Daily Puzzle",
        "whiteToMove": "White to move",
        "blackToMove": "Black to move"
      },
      "timeAgo": {
        "now": "just now",
        "minutes": "{{count}} min ago",
        "hours": "{{count}}h ago",
        "yesterday": "Yesterday",
        "days": "{{count}}d ago",
        "weeks": "{{count}}w ago",
        "months": "{{count}}mo ago"
      }
    }
  },
  "game": {
    "header": {
      "rated": "Rated",
      "casual": "Casual",
      "variantRules": "Variant rules"
    },
    "variants": {
      "international": "International Draughts 10×10",
      "internationalShort": "International 10×10",
      "internationalMedium": "International 10×10",
      "italian": "Italian Draughts 8×8",
      "italianShort": "Italian 8×8",
      "english": "English Draughts 8×8",
      "englishShort": "English 8×8",
      "englishBadge": "WCDF Official",
      "englishDesc": "Classic 8×8 draughts played worldwide. Mandatory capture, non-flying kings, men can capture kings, and no backward movement for men.",
      "brazilian": "Brazilian Draughts 8×8",
      "brazilianShort": "Brazilian 8×8",
      "frisian": "Frisian Draughts 10×10",
      "frisianShort": "Frisian 10×10",
      "frysk": "Frysk! 10×10",
      "fryskShort": "Frysk 10×10",
      "turkish": "Turkish Draughts 8×8",
      "turkishShort": "Turkish 8×8",
      "armenian": "Armenian Tama 8×8",
      "armenianShort": "Armenian 8×8",
      "russian": "Russian Draughts 8×8",
      "russianShort": "Russian 8×8",
      "spanish": "Spanish Draughts 8×8",
      "spanishShort": "Spanish 8×8",
      "triestine": "Triestine Draughts 10×10",
      "triestineShort": "Triestine 10×10",
      "canadian": "Canadian Draughts 12×12",
      "canadianShort": "Canadian 12×12",
      "nigerian": "Nigerian Draughts 10×10",
      "nigerianShort": "Nigerian 10×10",
      "ghanaian": "Ghanaian Draughts 10×10",
      "ghanaianShort": "Ghanaian 10×10",
      "pool": "Pool Checkers 8×8",
      "poolShort": "Pool 8×8",
      "czech": "Czech Draughts 8×8",
      "czechShort": "Czech 8×8",
      "thai": "Thai Makhos 8×8",
      "thaiShort": "Thai 8×8",
      "portuguese": "Portuguese Draughts 8×8",
      "portugueseShort": "Portuguese 8×8",
      "filipino": "Filipino Draughts 8×8",
      "filipinoShort": "Filipino 8×8",
      "malaysian": "Malaysian Draughts 12×12",
      "malaysianShort": "Malaysian 12×12",
      "german": "German Draughts 8×8",
      "germanShort": "German 8×8",
      "jamaican": "Jamaican Draughts 8×8",
      "jamaicanShort": "Jamaican 8×8",
      "sinhalese": "Sinhalese Draughts 8×8",
      "sinhaleseShort": "Sinhalese 8×8",
      "south_african": "South African Draughts 14×14",
      "south_africanShort": "S. African 14×14",
      "dameo": "Dameo 8×8",
      "dameoShort": "Dameo 8×8",
      "croda": "Croda 8×8",
      "crodaShort": "Croda 8×8"
    },
    "opponent": {
      "computer": "AI"
    },
    "modes": {
      "twoPlayers": "2 Players",
      "aiVeryEasy": "Very Easy",
      "aiEasy": "Easy",
      "aiMedium": "Medium",
      "aiHard": "Hard",
      "aiExpert": "Very Hard",
      "aiMaster": "Expert",
      "playOnline": "Play Online"
    },
    "timeControls": {
      "noTimeLimit": "No Time Limit",
      "blitz30": "Blitz 3+0",
      "blitz32": "Blitz 3+2",
      "blitz50": "Blitz 5+0",
      "blitz53": "Blitz 5+3",
      "rapid105": "Rapid 10+5",
      "rapid1510": "Rapid 15+10"
    },
    "turn": {
      "yourTurn": "Your turn",
      "opponentTurn": "Opponent's turn",
      "toMove": "To move",
      "aiThinking": "AI is thinking...",
      "aiTurn": "AI turn",
      "aiDeclinedDraw": "Computer declined the draw",
      "whiteToMove": "White to move",
      "blackToMove": "Black to move"
    },
    "result": {
      "youWin": "You Win!",
      "youLose": "You Lose!",
      "draw": "Draw!",
      "whiteWins": "White Wins!",
      "blackWins": "Black Wins!",
      "gameOver": "Game Over",
      "gameAbandoned": "Game Abandoned",
      "noWinner": "Game ended",
      "won": "Won",
      "lost": "Lost"
    },
    "drawCountdown": {
      "aria_one": "Automatic draw in {{count}} move if only kings move",
      "aria_other": "Automatic draw in {{count}} moves if only kings move"
    },
    "frisianCountdown": {
      "aria_one": "Automatic draw in {{count}} move: two kings against one",
      "aria_other": "Automatic draw in {{count}} moves: two kings against one"
    },
    "endReason": {
      "checkmate": "no moves left",
      "noLegalMoves": "has no legal moves remaining.",
      "whiteNoMoves": "White has no legal moves remaining.",
      "blackNoMoves": "Black has no legal moves remaining.",
      "drawEnded": "The game ended in a draw.",
      "gameAbandoned": "The game was abandoned.",
      "noWinner": "The game ended with no winner.",
      "gameEnded": "The game has ended.",
      "resignation": "resignation",
      "disconnection": "disconnection",
      "fiftyMoves": "fifty move rule",
      "timeout": "timeout",
      "agreement": "draw by agreement",
      "walkover": "walkover",
      "firstKing": "First king",
      "sideResigned": "{{side}} resigned.",
      "sideTimeout": "{{side}} ran out of time.",
      "sideNoPieces": "{{side}} has no pieces left.",
      "moveLimit": "Too many moves without a capture.",
      "repetition": "Same position repeated three times.",
      "endgameDraw": "Theoretically drawn endgame.",
      "sideZugzwang": "{{side}} is in zugzwang: every move loses.",
      "loneKing": "A lone king beats a lone man.",
      "sideSinglePiece": "{{side}} was left with a single piece.",
      "drawAgreed": "Draw by agreement.",
      "sideNoFirstMove": "{{side}} did not move in time.",
      "noFirstMove": "First move not played in time."
    },
    "actions": {
      "newGame": "New Game",
      "resign": "Resign",
      "endGame": "End",
      "leaveGame": "Leave Game",
      "backToLobby": "Back to Lobby",
      "offerDraw": "Draw",
      "drawOffered": "Your opponent offers a draw",
      "drawSent": "Draw offered…",
      "acceptDraw": "Accept",
      "declineDraw": "Decline",
      "drawDeclined": "Your opponent declined the draw",
      "drawMoveFirst": "Move first",
      "drawMustMoveFirst": "Play a move before offering a draw again.",
      "drawNoneLeft": "No offers left",
      "drawLimitReached": "You have used all your draw offers in this game.",
      "drawTooFast": "Too many draw offers. Wait a moment.",
      "requestTakeback": "Take back",
      "takebackRequested": "Takeback requested…",
      "opponentRequestsTakeback_one": "Opponent asks to take back {{count}} move",
      "opponentRequestsTakeback_other": "Opponent asks to take back {{count}} moves",
      "acceptTakeback": "Accept",
      "declineTakeback": "Decline",
      "takebackDeclined": "Your takeback was declined",
      "takebackAccepted": "Your takeback was accepted",
      "takebackDisabledRated": "Takeback is disabled in rated games",
      "focus": "Focus",
      "focusExit": "Exit",
      "peek": "Peek",
      "boardSize": "Board size",
      "boardBigger": "Bigger board",
      "boardSmaller": "Smaller board",
      "flipBoard": "Flip"
    },
    "confirmLeave": "Are you sure you want to leave the game?",
    "confirmLeaveTitle": "Leave game?",
    "confirmLeaveCancel": "Cancel",
    "confirmLeaveButton": "Leave",
    "confirmResignTitle": "Resign?",
    "confirmResign": "Are you sure you want to resign? You will lose the game.",
    "confirmEndGameTitle": "End the game?",
    "confirmEndGame": "The game will end with no winner.",
    "clock": {
      "white": "White",
      "black": "Black"
    },
    "aborted": {
      "opponentLeft": "Your opponent left before the game started — finding you a new opponent…",
      "opponentDidNotMove": "Your opponent did not move in time — game cancelled."
    },
    "disconnection": {
      "opponentDisconnected": "Opponent Disconnected",
      "waitingToReconnect": "Waiting for opponent to reconnect...",
      "opponentLeft": "Opponent has left the game",
      "disconnected": "Disconnected",
      "notPresent": "Not here",
      "avvisoMaiArrivato": "Opponent hasn't shown up: if they don't, you win when their clock runs out.",
      "avvisoDecideOrologio": "Opponent disconnected: if they don't return, you win when their clock runs out.",
      "avvisoGrazia": "Opponent disconnected: if they don't return within {{secondi}} s, you win.",
      "avvisoMaiArrivatoTuoTurno": "Opponent hasn't shown up: make your move; if they don't come, you win when their clock runs out.",
      "avvisoDecideOrologioTuoTurno": "Opponent disconnected: make your move; if they don't return, you win when their clock runs out."
    },
    "sidebar": {
      "moves": "Moves",
      "openingNumbered": "Opening No. {{n}}",
      "openingDrawn": "Drawn opening",
      "chat": "Chat",
      "spectators": "Spectators",
      "noMoves": "No moves yet",
      "viewMove": "View position after move {{n}}",
      "goToStart": "Go to start",
      "prevMove": "Previous move",
      "nextMove": "Next move",
      "goLive": "Go to current position",
      "play": "Play",
      "pause": "Pause",
      "position": "Position in the line",
      "showMoves": "Show moves",
      "hideMoves": "Hide moves"
    },
    "blind": {
      "lastMove": "Last move",
      "promoted": "Kinged",
      "noPeeks": "Played without a single peek.",
      "peeks_one": "You peeked {{count}} time.",
      "peeks_other": "You peeked {{count}} times."
    },
    "confirmDrawTitle": "Draw?",
    "confirmDraw": "End the game as a draw? Both players must agree.",
    "match": {
      "playReturn": "Play the return leg"
    },
    "primaMossa": {
      "secondi_one": "{{count}}s",
      "secondi_other": "{{count}}s",
      "ariaVoid_one": "First move within {{count}} second, or the game is cancelled",
      "ariaVoid_other": "First move within {{count}} seconds, or the game is cancelled",
      "ariaForfeit_one": "First move within {{count}} second, or you lose by forfeit",
      "ariaForfeit_other": "First move within {{count}} seconds, or you lose by forfeit"
    },
    "saluto": {
      "invia": "Wish your opponent a good game",
      "mittente": "{{username}}:",
      "ancheATe": "You too",
      "inviato": "Greeting sent"
    }
  },
  "online": {
    "title": "Online Play",
    "playOnline": "Play Online",
    "connecting": "Connecting to server...",
    "connectionFailed": "Connection Failed",
    "couldNotConnect": "Could not connect to game server.",
    "error": "Error",
    "room": {
      "title": "Room",
      "code": "Room code",
      "shareCode": "Share this room code:",
      "playAs": "You play as",
      "waitingForOpponent": "Waiting for Opponent"
    },
    "lobby": {
      "findMatch": "Find Match",
      "matchmakingByRating": "Automatic matchmaking by rating",
      "signInToMatch": "Sign in to use automatic matchmaking with rating",
      "createGame": "Create a Game",
      "selectVariantAndTime": "Select variant and time control",
      "createRoom": "Create Room",
      "joinGame": "Join a Game",
      "enterRoomCode": "Enter a room code to join",
      "join": "Join",
      "playWithFriends": "or play with friends"
    },
    "matchmaking": {
      "findingOpponent": "Finding Opponent...",
      "matchingSimilarSkill": "Matching you with a player of similar skill...",
      "creatingRoom": "Creating room...",
      "joiningRoom": "Joining room...",
      "estimatedWait": "Estimated wait: ~{{seconds}}s",
      "timeout": "No opponent found. Try again."
    },
    "errors": {
      "authRequired": "You must be signed in to play online.",
      "alreadyInQueue": "You are already searching for a match.",
      "alreadyInGame": "You are already in a game.",
      "generico": "Something went wrong. Try again.",
      "nonConnesso": "You are not connected to the server.",
      "partitaSparita": "This game no longer exists.",
      "drawOfferFailed": "Could not offer a draw.",
      "serverRestart": "The server is restarting: the game will resume shortly. If it does not come back, reload the page.",
      "sfidaTroppeRichieste": "You have sent too many challenges in a row. Wait a moment.",
      "avversarioOffline": "This player has gone offline.",
      "avversarioInPartita": "This player is already in a game. Try again when they finish.",
      "seiInGara": "You are in a running tournament or arena: finish that one first.",
      "avversarioInGara": "This player is playing in a tournament or arena.",
      "troppePosizioni": "Too many custom positions in a row. Wait a moment.",
      "impostazioniNonValide": "These settings are not valid. Check them and try again.",
      "soloIscritti": "This player can only play casual games.",
      "avversarioNonDisturbare": "This player is not accepting challenges. Try again later.",
      "sfidaGiaInVolo": "You already have a challenge waiting for an answer. Cancel it first.",
      "sfidaGiaMandata": "You have already challenged this player: wait for their answer."
    },
    "challenge": {
      "challenge": "Challenge",
      "sendChallenge": "Direct challenge",
      "incomingChallenge": "Incoming Challenge",
      "tabBadge": "Challenge!",
      "send": "Send",
      "accept": "Accept",
      "decline": "Decline",
      "cancel": "Cancel",
      "loginRequired": "Sign in to see online players and send challenges",
      "waitingForResponse": "Waiting for {{username}}...",
      "declined": "Challenge declined",
      "expired": "Challenge expired",
      "cancelled": "Challenge cancelled",
      "color": "Color",
      "gameType": "Game type",
      "colorRandom": "Random",
      "rated": "Rated (no guests)",
      "casual": "Casual",
      "gameTypeAny": "Rated/Casual",
      "registeredOnly": "Registered only",
      "registeredOnlyNote": "Only registered players can play this game.",
      "opponentGuestNoRated": "This opponent is a guest: the game cannot be rated.",
      "mode": "Mode",
      "modeNormal": "Standard",
      "modeBreakthrough": "Breakthrough",
      "modeAntidraughts": "Antidraughts",
      "modeBlind": "Blindfold",
      "modeInfoLabel": "About the game modes",
      "modeBreakthroughInfo": "The first player to promote a man to king wins immediately.",
      "modeAntidraughtsInfo": "Misère: you win by losing — first to run out of pieces, or of legal moves.",
      "modeBlindInfo": "The pieces are invisible: you play from memory, as if blindfolded. The rules are the normal ones.",
      "opening": "Opening",
      "legs": "Games",
      "legsOne": "Single game",
      "legsTwo": "Home and away",
      "openingDrawnSingleLegCasual": "With this opening a single game does not compensate the drawn advantage: the game is always casual.",
      "time": "Time",
      "increment": "Increment",
      "noClockCasual": "Games without a time limit are always casual.",
      "link": {
        "inviteFriend": "Invite a friend",
        "title": "Challenge a friend",
        "intro": "Send this link to anyone: the first person to open it plays you, no account needed.",
        "share": "Share",
        "copy": "Copy link",
        "copied": "Copied!",
        "copyFailed": "Could not copy the link. Select it and copy it manually.",
        "expiresIn": "The link is valid for another {{time}}.",
        "startingSoon": "The game is about to start...",
        "friendAccepted": "{{name}} accepted your challenge!",
        "cancelLink": "Cancel the challenge",
        "shareTitle": "Draughts challenge",
        "shareText": "Play me at draughts!",
        "shareTextWith": "Play me at draughts — {{summary}}",
        "challengesYou": "{{name}} challenges you at draughts",
        "playNow": "Play now",
        "haveAccount": "I already have an account",
        "guestCasualNote": "Playing as a guest makes this a casual game (it does not affect ratings).",
        "waitingChallengerTitle": "Challenge accepted",
        "waitingChallenger": "Waiting for {{name}} to come back online. The game will start by itself.",
        "unavailableTitle": "Challenge unavailable",
        "cancelledByChallenger": "The player who challenged you cancelled the game.",
        "expiredOrGone": "This link has expired or is no longer valid. Ask your friend for a new one.",
        "backHome": "Back to home"
      },
      "opening_free": "Free move",
      "opening_random1": "1 random move",
      "opening_random2": "2 random moves",
      "opening_random3": "3 random moves",
      "opening_ballot1": "Table C - 1N/1B",
      "opening_ballot2": "Table B - 2N/2B",
      "opening_ballot3": "Table {{tables}} - 3N/3B",
      "opening_ballot4": "General table",
      "opening_single": "Fixed opening",
      "openingInfoLabel": "About the openings",
      "openingInfo": "The “Table” entries draw from the official F.I.D. tables: the number in brackets is how many openings the draw picks from, and the cap (1N/1B … 4N/4B) limits how lopsided it can be. Up to Table B a single game still counts for the rating; above that you need a two-game match. The “random moves” entries draw from every legal move instead, with no cap at all: from 2 moves up they need a two-game match.",
      "openingInfoRandom": "The first half-moves are drawn at random from every legal move: the number in brackets is how many different combinations can come up. This variant has no official opening tables. From 2 moves up the draw can favour one colour, so the game only counts for the rating as a two-game match.",
      "openingTablesLink": "See the opening tables",
      "guestCannotChallenge": "Direct challenges are for registered players. Sign in or create a free account to send them.",
      "guestCasualInvite": "Sign in or create a free account to play rated games.",
      "changeOpponent": "Change",
      "challengePlayer": "Challenge {{username}}",
      "tableOpen": {
        "title": "{{username}} already has an open table",
        "other": "Send a different challenge"
      }
    },
    "status": {
      "playing": "Playing",
      "playingWith": "Playing vs {{username}}",
      "waiting": "Waiting",
      "away": "Away",
      "busy": "Busy"
    },
    "chooseOpponent": "Choose who to challenge",
    "ratingsBucket": "Ratings:",
    "onlinePlayers": "Players online",
    "loadingPlayers": "Loading players...",
    "noPlayersOnline": "Nobody else is online right now",
    "reloadIn": "Reloading in {{seconds}} s",
    "reloadInShort": "{{seconds}} s",
    "rematch": {
      "rematch": "Rematch",
      "accept": "Accept",
      "decline": "Decline",
      "sessionScore": "Score",
      "opponentWantsRematch": "Opponent wants a rematch!",
      "declined": "Your opponent declined the rematch",
      "expired": "The rematch offer expired",
      "invite": {
        "incoming": "Rematch invite",
        "tabBadge": "Rematch!",
        "message": "<b>{{name}}</b> ({{rating}}) wants a rematch · <b>{{timeControl}}</b> · {{variant}}",
        "messageNoRating": "<b>{{name}}</b> wants a rematch · <b>{{timeControl}}</b> · {{variant}}"
      },
      "waitingForOpponent": "Waiting for opponent...",
      "newOpponent": "Back to Home"
    },
    "match": {
      "legFirst": "First leg",
      "legSecond": "Return leg",
      "legOf": "Game {{leg}} of {{total}}",
      "legShort": "{{leg}}/{{total}}",
      "score": "Match",
      "returnStartsIn": "Return leg starts in {{seconds}}s",
      "leavingForfeits": "Leaving now forfeits the return leg.",
      "ratingAtMatchEnd": "Your rating updates at the end of the match.",
      "ready": "Ready",
      "opponentReady": "Your opponent is ready",
      "waitingOpponent": "Waiting for your opponent...",
      "complete": "Match over",
      "newMatch": "New match",
      "twoLegsShort": "2 games"
    },
    "connectedCount": "{{count}} Online",
    "viewProfile": "Profile",
    "connessionePersa": {
      "titolo": "Connection lost",
      "corpo": "Trying to get you back to the board.",
      "riprova": "Retry",
      "esci": "Leave"
    },
    "partitaFinitaMentreEriVia": "The game ended while you were away.",
    "sessioneAltrove": {
      "titolo": "Open on another device",
      "corpo": "You opened the game somewhere else, so this window no longer receives moves or challenges.",
      "usaQui": "Use here"
    }
  },
  "lobby": {
    "title": "Play",
    "quickPlay": "Quick play",
    "customGame": "Custom game",
    "opponent": "Opponent",
    "opponentOnline": "Online (random)",
    "opponentInPerson": "In person",
    "startInPerson": "Start the game",
    "inPersonNote": "Two players on the same device. It does not count towards your rating.",
    "openTable": "Open the table",
    "openTables": "Tables waiting",
    "noTablesInVariant": "No {{variant}} table right now. Press a cadence to open yours.",
    "noTablesInVariantOrOther": "No {{variant}} table right now. Press a cadence to open yours, or sit at one from another variant:",
    "otherVariants": "Other variants",
    "sit": "Sit",
    "cancelTable": "Cancel",
    "waitingAtTable": "Waiting for an opponent",
    "inQueue": "In queue",
    "tableExpired": "Your table expired after 10 minutes without an opponent. Open a new one whenever you like.",
    "customPosition": "Custom position",
    "errors": {
      "inCompetition": "Leave the arena or tournament first.",
      "rateLimited": "Too many tables. Wait a moment.",
      "tableGone": "That table is no longer available.",
      "hostGone": "The player who opened this table is no longer here.",
      "ownTable": "This is your own table.",
      "invalidSettings": "Those settings are not valid.",
      "startFailed": "The game could not be started. Try again.",
      "generic": "Something went wrong. Try again."
    }
  },
  "spectate": {
    "watch": "Watch",
    "watchPlayer": "Watch {{username}}'s game",
    "watchPair": "Watch {{a}} vs {{b}}",
    "watching": "Watching",
    "leave": "Leave",
    "loading": "Loading game...",
    "turnWhite": "White to move",
    "turnBlack": "Black to move",
    "whiteWins": "White wins",
    "blackWins": "Black wins",
    "draw": "Draw",
    "gameOver": "Game over",
    "betweenLegs": "First leg over: the return leg starts soon",
    "unavailable": "This game is no longer available",
    "error": {
      "notPlaying": "This player is no longer in a game.",
      "unavailable": "This game is no longer available.",
      "busy": "You cannot watch a game while you are playing.",
      "self": "This is your own game — open it from your board."
    },
    "watchers": {
      "empty": "No one is watching right now."
    }
  },
  "auth": {
    "signIn": "Sign In",
    "signUp": "Sign up",
    "preferredVariantHint": "You can change this at any time",
    "createAccount": "Create Account",
    "noAccount": "Don't have an account?",
    "hasAccount": "Already have an account?",
    "fields": {
      "username": "Username",
      "email": "Email",
      "password": "Password",
      "confirmPassword": "Confirm Password",
      "emailOrUsername": "Email or Username"
    },
    "placeholders": {
      "chooseUsername": "Choose a username",
      "yourEmail": "your@email.com",
      "atLeast8Chars": "At least 8 characters",
      "confirmYourPassword": "Confirm your password",
      "enterEmailOrUsername": "Enter email or username",
      "yourPassword": "Your password"
    },
    "errors": {
      "passwordsNoMatch": "Passwords do not match",
      "passwordTooShort": "Password must be at least 8 characters",
      "usernameTooShort": "Username must be at least 3 characters",
      "passwordRequirements": "Password must contain at least one uppercase letter, one lowercase letter, and one number",
      "network": "No internet connection. Check your connection and try again.",
      "guestLoginFailed": "Couldn't start a guest session. Check your connection and try again.",
      "guestLoginRateLimited": "Too many guest sign-ins from this network. Try again in a few minutes, or sign in with your account."
    },
    "validation": {
      "usernameChars": "Only letters, numbers, and underscores",
      "invalidEmail": "Enter a valid email address",
      "min8": "8+ chars",
      "uppercase": "uppercase",
      "lowercase": "lowercase",
      "number": "number"
    },
    "playAsGuest": "Play as Guest",
    "guestBanner": "You're playing as a guest.",
    "guestBannerCta": "Register to save your progress.",
    "guestUpgrade": "Create Account",
    "guestRestriction": "This feature requires a registered account",
    "guestCannotTournament": "Register to join tournaments",
    "guestCannotChallenge": "Register to challenge players",
    "forgotPassword": "Forgot Password?",
    "forgotPasswordDesc": "Enter your email and we'll send you a link to reset your password.",
    "sendResetLink": "Send Reset Link",
    "resetEmailSent": "Check Your Email",
    "checkSpam": "Don't see it? Check your spam folder.",
    "backToLogin": "Back to Sign In",
    "resetPassword": "Reset Password",
    "resetPasswordDesc": "Enter your new password below.",
    "newPassword": "New Password",
    "confirmPassword": "Confirm Password",
    "resetSuccess": "Password updated successfully. You can now sign in.",
    "resetExpired": "This reset link has expired. Please request a new one.",
    "resetInvalid": "Invalid or expired reset link.",
    "verifyEmail": {
      "title": "Check Your Email",
      "checkInbox": "We've sent a verification link to {{email}}. Click the link to activate your account.",
      "spamHint": "Don't see it? Check your spam folder.",
      "pageTitle": "Email Verification",
      "verifying": "Verifying your email...",
      "success": "Email verified. Your account is active.",
      "successAndBack": "Email verified. Taking you back to the tournament.",
      "verifyButton": "Verify My Email",
      "error": "Verification failed. Please try again.",
      "loginBlocked": "Please verify your email before signing in",
      "resendLink": "Resend verification email",
      "resendSent": "Verification email sent!",
      "enterEmailToResend": "Please log in with your email address to resend verification",
      "wrongAddress": "Wrong address?",
      "changeAddress": "Correct the address",
      "newAddressLabel": "New email address",
      "passwordLabel": "The password you just chose",
      "changeSubmit": "Send to the new address",
      "changeSent": "If the account exists and is awaiting verification, we've sent the link to the new address.",
      "changeFailed": "Couldn't change the address. Try again in a few minutes."
    }
  },
  "profile": {
    "title": "Profile",
    "notFound": "Profile Not Found",
    "userNotFound": "User not found",
    "memberSince": "Member since {{date}}",
    "goBack": "Go Back",
    "loadingProfile": "Loading profile...",
    "tabs": {
      "overview": "Overview",
      "games": "Games",
      "stats": "Stats"
    },
    "variants": {
      "all": "All"
    },
    "stats": {
      "rating": "Rating",
      "games": "Games",
      "wins": "Wins",
      "losses": "Losses",
      "draws": "Draws",
      "winRate": "Win Rate",
      "winRateShort": "Win rate",
      "winLossBreakdown": "Wins · Draws · Losses",
      "peakRating": "Peak rating",
      "streak": "Streak",
      "bestStreak": "Best",
      "avgTime": "Avg Time",
      "title": "Detailed Statistics",
      "comingSoon": "Coming soon...",
      "loading": "Loading statistics...",
      "noData": "No games played yet. Play some games to see your statistics!",
      "byTimeControl": "Performance by Time Control",
      "byColor": "Performance by Color",
      "general": "General",
      "asWhite": "As White",
      "asBlack": "As Black",
      "totalGames": "Total Games",
      "avgMoves": "Average Moves",
      "gamesShort": "games",
      "mostActive": "Most active players",
      "mostActiveEmpty": "No games in this variant yet.",
      "viewFullLeaderboard": "View the full leaderboard",
      "ratingEvolution": "Rating trend · last 30 days",
      "chartComingSoon": "History coming soon",
      "peakShort": "Peak",
      "barraEsito": "{{win}}% wins, {{draw}}% draws, {{loss}}% losses",
      "percentualeVittorie": "{{rate}}% win rate",
      "siglaVittorie": "W",
      "siglaPatte": "D",
      "siglaSconfitte": "L"
    },
    "games": {
      "today": "Today",
      "yesterday": "Yesterday",
      "daysAgo": "{{days}} days ago",
      "weeksAgo": "{{weeks}}w ago",
      "moves": "moves",
      "sourceArena": "Arena",
      "sourceTournament": "Tournament",
      "loading": "Loading games...",
      "noGames": "No games found",
      "clearFilters": "Clear filters",
      "clearFiltersActive": "Clear active filters",
      "loadMore": "Load More",
      "showing": "{{count}} games",
      "clickViewAll": "Click \"View all\" to see game history",
      "filterResult": "Result",
      "filterTimeControl": "Cadence",
      "filterVariant": "Variant",
      "filterOpponent": "Opponent",
      "filters": {
        "all": "All",
        "wins": "Wins",
        "draws": "Draws",
        "losses": "Losses",
        "allVariants": "All Variants",
        "allTimeControls": "All Time Controls",
        "vsMe": "Against me"
      }
    },
    "challenge": "Challenge",
    "settings": "Settings",
    "gameSettings": "Game settings",
    "preferredVariant": "Preferred variant",
    "preferredCadence": "Preferred cadence",
    "accountSettings": "Account",
    "audioHaptics": "Sound & Vibration",
    "changePassword": "Change password",
    "changePasswordSub": "Update your password",
    "currentPassword": "Current password",
    "newPassword": "New password",
    "passwordChanged": "Password changed successfully",
    "analyticsLabel": "Analytics cookies",
    "language": "Language",
    "country": "Country",
    "countryNone": "Not set",
    "logout": "Logout",
    "logoutSub": "Log out of your account",
    "exportData": "Export my data",
    "exportDataSub": "Download a JSON of your data",
    "deleteAccount": {
      "button": "Delete account",
      "sub": "Permanently delete your account",
      "title": "Delete Account",
      "warning": "This action is permanent and cannot be undone. All your data will be deleted.",
      "confirmPassword": "Enter your password to confirm",
      "confirm": "Delete permanently",
      "error": "Failed to delete account"
    },
    "graphics": {
      "title": "Graphics",
      "pieceShape": "Piece shape",
      "pieceStyle": "Piece style",
      "kingIcon": "King icon",
      "pieceColor": "Piece color",
      "pieceColorAutoHint": "Piece colors change with each variant.",
      "pieceMaterial": "Piece material",
      "boardColor": "Board color",
      "boardColorAutoHint": "Board colors change with each variant.",
      "boardMaterial": "Board material",
      "boardNotation": "Board notation",
      "notation": "Notation",
      "shapes": {
        "round": "Round",
        "donut": "Donut",
        "square": "Square",
        "rhombus": "Rhombus",
        "triangle": "Triangle",
        "star": "Star",
        "heart": "Heart"
      },
      "styles": {
        "3d-stacked-engraved": "3D stacked, engraved",
        "3d-stacked-smooth": "3D stacked, smooth",
        "3d-crown": "3D with crown",
        "flat-plain": "Flat, plain",
        "flat-engraved": "Flat, engraved"
      },
      "kingIcons": {
        "crown": "Crown",
        "ring": "Ring",
        "star": "Star",
        "diamond": "Diamond",
        "none": "None"
      },
      "crownType": "Crown type",
      "crownTypes": {
        "classic": "Classic",
        "plain": "Simple",
        "diadem": "Diadem",
        "lily": "Fleur-de-lis",
        "imperial": "Imperial"
      },
      "pieceColors": {
        "auto": "Auto (per variant)",
        "custom": "Custom…",
        "italian": "Italian",
        "international": "International",
        "english": "English",
        "brazilian": "Brazilian",
        "classic": "Classic",
        "white-black": "White/Black",
        "red-black": "Red/Black",
        "blue-red": "Blue/Red",
        "orange-blue": "Orange/Blue (color-blind)",
        "silver-gold": "Silver/Gold",
        "coral-teal": "Coral/Teal",
        "green-purple": "Green/Purple",
        "pink-navy": "Pink/Navy"
      },
      "materials": {
        "plastic": "Plastic",
        "marble": "Marble",
        "glass": "Glass",
        "wood": "Wood"
      },
      "boards": {
        "auto": "Auto (per variant)",
        "custom": "Custom…",
        "wood-classic": "International",
        "italian": "Italian",
        "english": "English",
        "brazilian": "Brazilian",
        "walnut": "Walnut",
        "green-cream": "Green/Cream",
        "blue-grey": "Blue/Grey",
        "marble": "Marble",
        "high-contrast": "High contrast",
        "mahogany": "Mahogany",
        "ocean": "Ocean",
        "purple-lavender": "Purple/Lavender",
        "rose": "Rose"
      },
      "notations": {
        "none": "None",
        "numeric": "Numbers",
        "algebraic": "Coordinates"
      },
      "hue": "Hue",
      "customPieceLight": "Light pieces",
      "customPieceDark": "Dark pieces",
      "customBoardLight": "Light squares",
      "customBoardDark": "Dark squares",
      "picker": {
        "edit": "Edit colors",
        "hex": "Hex",
        "area": "Saturation and brightness",
        "saturation": "Saturation",
        "brightness": "Brightness",
        "tooClose": "These two colors are very similar — pieces or squares may be hard to tell apart."
      },
      "uiTheme": "App theme",
      "themes": {
        "light": "Light",
        "dark": "Dark"
      }
    },
    "game": {
      "title": "Game",
      "moveSound": "Enable move sounds",
      "lowTimeSound": "Enable low-time sound",
      "notificationSound": "Enable notification sounds",
      "vibration": "Enable vibration for moves"
    },
    "gameplay": {
      "title": "Gameplay",
      "showMoveHints": "Show possible moves",
      "showLastMove": "Highlight last move",
      "showLastMoveCaptures": "Highlight captures",
      "premove": "Enable premoves"
    },
    "avatar": {
      "title": "Choose an avatar",
      "choose": "Available avatars",
      "remove": "No avatar",
      "edit": "Change avatar",
      "presets": {
        "crown": "Crown",
        "star": "Star",
        "flame": "Flame",
        "zap": "Lightning",
        "shield": "Shield",
        "rocket": "Rocket",
        "gem": "Gem",
        "leaf": "Leaf",
        "moon": "Moon",
        "sun": "Sun",
        "heart": "Heart",
        "ghost": "Ghost"
      }
    },
    "viewProfileOf": "View {{username}}'s profile",
    "report": {
      "trigger": "Report {{username}}",
      "title": "Report {{username}}",
      "intro": "Tell us what is wrong with this profile. A moderator will look into it.",
      "reasonLabel": "Reason",
      "reasons": {
        "offensive_username": "Offensive username",
        "offensive_avatar": "Offensive profile picture",
        "harassment": "Harassment or threats",
        "spam": "Spam or advertising",
        "other": "Other"
      },
      "noteLabel": "Details (optional)",
      "notePlaceholder": "Anything that helps us understand",
      "privacyHint": "The report is kept for {{days}} days for moderation. The profile is public: we store no copy of it.",
      "submit": "Send report",
      "sending": "Sending...",
      "done": "Report sent. Thank you.",
      "errors": {
        "duplicate": "You have already reported this player. A moderator is looking into it.",
        "notFound": "This player is no longer available.",
        "self": "You cannot report yourself.",
        "registeredOnly": "You need a registered account to report from here.",
        "rateLimited": "Too many reports. Please try again later.",
        "generic": "The report could not be sent. Please try again."
      }
    }
  },
  "gamesHistory": {
    "title": "Games History",
    "gamesPlayed": "{{count}} games played",
    "noGames": "No games yet. Play some games online to see them here!",
    "signInToView": "Sign in to view your games history.",
    "loadingGames": "Loading games...",
    "loadingGame": "Loading game...",
    "failedToLoad": "Failed to load games",
    "moves": "{{count}} moves"
  },
  "replay": {
    "backToGames": "Back to Games",
    "loadFailed": "We couldn't open this game. Please try again.",
    "result": {
      "whiteWins": "White wins",
      "blackWins": "Black wins",
      "draw": "Draw"
    },
    "controls": {
      "goToStart": "Go to start",
      "previousMove": "Previous move",
      "nextMove": "Next move",
      "goToEnd": "Go to end",
      "play": "Play",
      "pause": "Pause",
      "showMoves": "Show moves",
      "hideMoves": "Hide moves",
      "position": "Position in the game"
    },
    "downloadPdn": "Download PDN",
    "analyzeGame": "Analyze game",
    "share": "Share",
    "shareCopied": "Link copied!",
    "shareTitle": "Draughts game",
    "shareText": "Check out this draughts game",
    "shareSheet": {
      "pdnTitle": "Download PDN",
      "withNotes": "With my notes ({{count}})",
      "withoutNotes": "Without notes",
      "pdnIntro": "The notes become comments inside the PDN file."
    }
  },
  "review": {
    "save": {
      "save": "Save game",
      "saved": "Saved",
      "title": "Save game",
      "intro": "Choose a folder to find this game again.",
      "confirm": "Save",
      "remove": "Remove from saved",
      "error": "Could not save the game"
    },
    "folders": {
      "unsorted": "No folder",
      "newLabel": "New folder",
      "newPlaceholder": "Folder name",
      "create": "Create",
      "duplicate": "A folder with this name already exists",
      "rename": "Rename",
      "renameFolder": "Rename “{{name}}”",
      "renameLabel": "New folder name",
      "renameError": "Could not rename the folder",
      "delete": "Delete",
      "deleteFolder": "Delete “{{name}}”",
      "deleteConfirm": "Delete?",
      "deleteHint": "The games aren’t deleted: they go back to “No folder”.",
      "deleteError": "Could not delete the folder",
      "filterLabel": "Folder",
      "savedOnly": "Saved only",
      "gameCount_one": "{{count}} game",
      "gameCount_other": "{{count}} games"
    },
    "notes": {
      "add": "Add note",
      "atStart": "Note on the starting position",
      "atMove": "Note at move {{ply}}",
      "placeholder": "Write a note about this position…",
      "save": "Save note",
      "delete": "Delete note",
      "jumpTo": "Go to the note at move {{ply}}",
      "error": "Could not save the note",
      "hasNote": "This position has a note"
    }
  },
  "leaderboard": {
    "title": "Leaderboard",
    "subtitle": "Top 100 Players",
    "loading": "Loading leaderboard...",
    "empty": "No players with completed games yet.",
    "allTime": "Rating",
    "mostGames": "Most active",
    "bullet": "Bullet",
    "blitz": "Blitz",
    "rapid": "Rapid",
    "classical": "Classical",
    "columns": {
      "rank": "#",
      "player": "Player",
      "rating": "Rating",
      "class": "Class",
      "games": "Games",
      "days": "Days",
      "record": "Best"
    },
    "period": {
      "label": "Days",
      "days": "{{days}} days",
      "all": "All time"
    },
    "emptyPeriod": "No games in this variant in the last {{days}} days.",
    "emptyStreak": "Nobody has an active streak right now.",
    "classes": {
      "novice": "Novice",
      "intermediate": "Intermediate",
      "advanced": "Advanced",
      "expert": "Expert",
      "master": "Master",
      "grandmaster": "Grandmaster",
      "legend": "Legend"
    }
  },
  "tournament": {
    "title": "Tournaments",
    "subtitle": "Test your skills in competitive tournaments",
    "list": {
      "heroTitle": "The tournaments",
      "arenasLink": "See all arenas",
      "archive_one": "The last finished tournament.",
      "archive_other": "The last {{count}} finished tournaments."
    },
    "createTournament": "Create a tournament",
    "formats": {
      "arena": "Arena",
      "italoSwiss": "Round-robin/Swiss (by number of entrants)",
      "swiss": "Swiss system",
      "roundRobin": "Round Robin (Italian all-play-all)",
      "arenaShort": "Arena",
      "italoSwissShort": "Round-robin/Swiss",
      "swissShort": "Swiss",
      "roundRobinShort": "Round robin"
    },
    "filters": {
      "all": "All",
      "live": "Live",
      "upcoming": "Upcoming",
      "variant": "Variant",
      "status": "Status",
      "international": "International",
      "italian": "Italian",
      "english": "English",
      "brazilian": "Brazilian",
      "comingSoon": "Coming soon",
      "owner": "Ownership",
      "mine": "Mine"
    },
    "sections": {
      "live": "In Progress",
      "upcoming": "Upcoming",
      "finished": "Finished"
    },
    "status": {
      "live": "LIVE",
      "upcoming": "UPCOMING",
      "finished": "FINISHED",
      "scheduled": "SCHEDULED",
      "cancelled": "CANCELLED"
    },
    "card": {
      "rated": "Rated",
      "registered": "Registered",
      "gamesPlayed_one": "{{count}} game played",
      "gamesPlayed_other": "{{count}} games played",
      "players_one": "{{count}} player",
      "players_other": "{{count}} players",
      "starts": "Starts {{time}}",
      "startsAt": "Starts at {{time}}",
      "startsAtTomorrow": "Starts tomorrow at {{time}}",
      "startsAtDate": "Starts {{date}} at {{time}}",
      "startsInCountdown": "Starts in {{time}}",
      "startingNow": "Starting now!",
      "privateHint": "Private tournament: you need an invite or the password",
      "publicHint": "Public tournament: open to everyone",
      "private": "Private",
      "seats": "Seats",
      "yourPlace": "you {{rank}}th",
      "gettoneAlle": "Starts at",
      "gettoneDomani": "Tomorrow at",
      "gettoneData": "{{date}} at",
      "gettoneTra": "Starts in",
      "gettoneMin": "min"
    },
    "empty": {
      "live": "No live tournaments right now.",
      "upcoming": "No upcoming tournaments scheduled.",
      "all": "No tournaments available.",
      "mine": "You have no tournaments yet. Create one, or join with an invite.",
      "finished": "No finished tournaments yet.",
      "goLive": "See the live ones",
      "goUpcoming": "See what’s coming",
      "goFinished": "See the archive"
    },
    "loading": "Loading tournaments...",
    "notFound": "Tournament not found",
    "detail": {
      "timeControl": "Time Control",
      "duration": "Duration",
      "players": "Players",
      "games": "Games",
      "startsIn": "Starts {{time}}",
      "joinTournament": "Join Tournament",
      "register": "Register",
      "unregister": "Unregister",
      "leaveTournament": "Leave Tournament",
      "yourStats": "Your Stats",
      "points": "Points",
      "rank": "Rank",
      "askPassword": "Tournament password",
      "share": "Share invite",
      "shareStandings": "Share standings",
      "shareCopied": "Link copied",
      "cancelTournament": "Cancel tournament",
      "cancelConfirm": "The tournament disappears and everyone signed up is notified. This cannot be undone.",
      "cancelYes": "Yes, cancel it",
      "cancelNo": "No, keep it",
      "createdBy": "Created by {{username}}",
      "regenerate": "New keys",
      "regenerateHint": "The old link stops working. Pick a new password and send the invite again.",
      "regenerateNewPassword": "New password",
      "regenerateConfirm": "Make new keys",
      "regenerateCancel": "Never mind",
      "regenerateDone": "New keys made: the old link no longer works",
      "ratingFloor": "Minimum rating",
      "aiutoAssenza": "What happens if I don't play?",
      "aiutoApertura": "Why do some games start with moves already played?",
      "formatoTitolo": "How the format is decided",
      "formatoOraGirone": "With the players registered now ({{n}}) it would be an all-play-all.",
      "formatoOraSvizzero": "With the players registered now ({{n}}) it would be a Swiss system.",
      "formatoOraPochi": "At least {{min}} players are needed to start: there are {{n}} now.",
      "formatoPrevisto": "Expected",
      "seSvizzero": "If it is a Swiss system",
      "seGirone": "If it is an all-play-all",
      "punteggio": "Scoring"
    },
    "scoring": {
      "title": "Arena Scoring",
      "win": "Win: +{{points}}",
      "draw": "Draw: +{{points}}"
    },
    "standings": {
      "title": "Standings",
      "liveStandings": "Live Standings",
      "empty": "No players yet. Be the first to join!",
      "morePlayers_one": "+ {{count}} more player",
      "morePlayers_other": "+ {{count}} more players",
      "columns": {
        "rank": "#",
        "player": "Player",
        "points": "Points",
        "status": "Status",
        "winsDrawsLosses": "W/D/L",
        "winsDrawsLossesByes": "W/D/L/B",
        "byes": "Bye"
      },
      "status": {
        "playing": "Playing",
        "ready": "Ready",
        "paused": "Paused",
        "left": "Left",
        "offline": "Offline",
        "assente": "Absent",
        "haFinito": "Waiting",
        "riposa": "Resting",
        "disconnesso": "Disconnected"
      },
      "tied": "Tied",
      "tiebreakHelp": "How are ties broken?",
      "sdSigla": "H2H",
      "sdSpiega": "Ahead of {{nomi}} on head-to-head results among the tied players",
      "scoreSheet": {
        "label": "Form: {{esiti}}",
        "outcome": {
          "win": "won",
          "winPlus": "won, worth more",
          "draw": "drawn",
          "loss": "lost",
          "bye": "bye"
        },
        "clipped": "the oldest ones are cut off on the left",
        "hint": "All games, latest on the right",
        "hintRiposoSvizzero": "the square is a bye, worth the same as a win",
        "hintRiposoGirone": "the square is a bye, and scores nothing"
      }
    },
    "lobby": {
      "leaveTournament": "Leave Tournament",
      "waitingForOpponent": "Waiting for opponent...",
      "pts": "pts",
      "rank": "rank",
      "yourPosition": "Your Position"
    },
    "timer": {
      "remaining": "Remaining",
      "finished": "Finished",
      "started": "Started",
      "daysHours": "{{days}}d {{hours}}h"
    },
    "tabs": {
      "standings": "Standings",
      "games": "Games",
      "details": "Details",
      "participants": "Participants",
      "gamesPlaceholder": "Recent games will appear here"
    },
    "rules": {
      "title": "Scoring Rules"
    },
    "create": {
      "title": "Create a tournament",
      "infoAbout": "About {{campo}}",
      "nameLabel": "Tournament Name *",
      "namePlaceholder": "e.g., Sunday Blitz Arena",
      "nameRequired": "Tournament name is required",
      "aperturaUnicaHint": "One opening for every round and every game of the tournament — for a themed tournament built on a single opening",
      "aperturaUnicaScelta": "no. {{id}}",
      "aperturaUnicaScegli": "Choose the opening",
      "aperturaUnicaMancante": "Choose an opening to continue",
      "aperturaUnicaAmichevole": "This opening is too lopsided for a single game to even it out: the tournament is casual. With two legs it stays rated.",
      "nameLength": "Name must be 3-100 characters",
      "descriptionLabel": "Description (optional)",
      "descriptionPlaceholder": "Describe your tournament...",
      "timeControlLabel": "Time Control",
      "durationLabel": "Duration",
      "startsAtLabel": "Start time",
      "startsAtRange": "From 5 minutes to 14 days from now.",
      "startsAtInvalid": "Pick a time between 5 minutes and 14 days from now.",
      "visibilityLabel": "Visibility",
      "visibilityPublic": "Public",
      "visibilityPrivate": "Private",
      "passwordLabel": "Tournament password",
      "passwordHint": "You will be able to read it again later, so you can share it. Do not use your account password.",
      "passwordRequired": "A private tournament needs a password",
      "estimate": "{{players}} players, {{rounds}} rounds → about {{duration}}, ending around {{end}}",
      "estimateRange": "{{players}} players, {{roundsMin}} to {{roundsMax}} rounds → about {{duration}}, ending by {{end}}",
      "durationOptions": {
        "30min": "30 min",
        "1hour": "1 hour",
        "1.5hours": "1.5 hours",
        "2hours": "2 hours",
        "3hours": "3 hours"
      },
      "minRatingLabel": "Min Rating",
      "maxRatingLabel": "Max Rating",
      "ratedLabel": "Rated",
      "ratingFloorLabel": "Rating floor",
      "ratingFloorHint": "Below this rating you cannot enter. It is measured on your rating for this tournament’s variant and time control: anyone who has never played that combination counts as a newcomer. Rated tournaments only.",
      "ratingFloorNone": "None",
      "variantLabel": "Variant",
      "variantInternational": "International (10×10)",
      "variantItalian": "Italian (8×8)",
      "variantEnglish": "English (8×8)",
      "formatLabel": "Format",
      "maxPlayersLabel": "Max players",
      "thresholdLabel": "Swiss from",
      "thresholdHint": "From {{n}} entrants up it is played as a Swiss system; below that, an all-play-all. The rounds are set at start time, counting who turned up. With three or four entrants the all-play-all includes the return leg: still three rounds, but two games each, because one game per opponent would be too few.",
      "extraRoundLabel": "Extra rounds (Swiss)",
      "extraRoundHint": "One or two rounds more than the table gives, as far as the field can bear. It changes nothing in an all-play-all: there everyone meets everyone, and one round more would be a rematch for all.",
      "extraRoundsNone": "None",
      "extraRoundsOne": "+1 round",
      "extraRoundsTwo": "+2 rounds",
      "tooLongWarningSeats": "More than a day of play: remove some seats or shorten the clock.",
      "minPlayersLabel": "Min players",
      "minPlayersHint": "Below this number the tournament cancels itself at start time. The higher you set it, the likelier that is.",
      "seatsWarning": "Above this number nobody else can enter, and you cannot change it later.",
      "submitButton": "Create Tournament",
      "submitting": "Creating...",
      "failedToCreate": "Failed to create tournament",
      "arenaHint": "An arena has no rounds: you are paired continuously until the time runs out.",
      "arenaDurationHint": "How long the arena stays open. Eight hours at most.",
      "arenaSummary": "A {{duration}} arena, ending around {{end}}",
      "twoLegLabel": "Two legs",
      "twoLegHint": "Every pairing is played twice in a row, with colours swapped.",
      "twoLegItaloHint": "The same two players meet twice within the same round, with colours swapped and on the same opening: the round lasts twice as long, the number of rounds does not double. With three or four entrants the return leg is always played, whatever this switch says.",
      "boostLabel": "Boost",
      "boostHint": "Players can bet: they give up half the base time and the increment, and a win is worth double. Taken before their own first move. Switched off, nobody uses it in this arena.",
      "roundsHelp": "How many rounds are played?"
    },
    "games": {
      "allGames": "All Games",
      "myGames": "My Games",
      "noGames": "No games played yet",
      "moves": "moves",
      "analyze": "Analyze",
      "round": "Round {{n}}"
    },
    "participants": {
      "sortByScore": "By Score",
      "sortByRating": "By Rating",
      "sortByName": "A-Z",
      "status": {
        "playing": "Playing",
        "online": "Online",
        "offline": "Offline"
      }
    },
    "matchFound": {
      "title": "Match Found!",
      "opponent": "Opponent",
      "playAsWhite": "Playing as White",
      "playAsBlack": "Playing as Black",
      "startingIn": "Starting in...",
      "startNow": "Start Now"
    },
    "postGame": {
      "currentRank": "Current Rank",
      "continue": "Continue"
    },
    "signInToJoin": "Please sign in to join tournaments",
    "roundRobin": {
      "scontroDiretto": "Direct encounter among the players on the same score (shown as «H2H» in the standings)",
      "tiebreakerInfo": "Tiebreakers: wins, direct encounter, Sonneborn-Berger, rating change in the tournament"
    },
    "swiss": {
      "roundOf": "Round {{current}} of {{total}}",
      "scoringWin": "Win: +{{points}}",
      "scoringDraw": "Draw: +{{points}}",
      "scoringLoss": "Loss: {{points}}",
      "buchholz": "BH",
      "sb": "SB",
      "variazione": "Δ",
      "variazioneTitolo": "Rating change in the tournament",
      "criterioVittorie": "Number of wins",
      "tiebreakersTitle": "Tiebreakers",
      "buchholzCut1": "Buchholz (Cut 1)",
      "sonnebornBerger": "Sonneborn-Berger (SB)",
      "cannotJoinInProgress": "This Swiss tournament is already in progress. You cannot join mid-tournament.",
      "returnLegPending": "The return leg is about to start: same opponents, colours swapped.",
      "waitingBetweenRounds": "Waiting for next round...",
      "waitingFinalResults": "Waiting for the final results...",
      "waitingForRoundEnd": "Waiting for round to end...",
      "tiebreakerInfo": "Tiebreakers: Buchholz Cut 1, Sonneborn-Berger, wins, rating change in the tournament",
      "byeRoundPunti": "You rest this round: +{{punti}} points, already in the standings.",
      "byeRoundNessunPunto": "You rest this round: in a round robin the bye is worth no points.",
      "byeProssimoTurno": "The next round starts by itself when the other games finish.",
      "byeUltimoTurno": "The final results arrive when the other games finish.",
      "returnLegTra": "The return leg starts in {{secondi}} s: same opponents, colours swapped.",
      "partiteConcluse": "Games finished: {{completate}} of {{totali}}",
      "turnoParteDaSolo": "The next round starts by itself",
      "nonCiSiRitira": "Once the tournament has started you can't withdraw: if you don't play, you stay paired and lose your games on time."
    },
    "errors": {
      "authRequired": "Sign in to take part in a tournament.",
      "guestNotAllowed": "Tournaments are for registered accounts.",
      "notAllowed": "Not allowed.",
      "notFound": "This tournament no longer exists.",
      "userNotFound": "Player not found.",
      "invalidInput": "Invalid request.",
      "rateLimited": "Too many requests — wait a moment.",
      "joinFailed": "Could not join. Try again.",
      "arenaPiena": "This arena is full: there are no seats left.",
      "arenaChiusa": "This arena is no longer accepting entries.",
      "giaIscritto": "You are already in this arena.",
      "arenaAnnullata": "This arena was cancelled: not enough players had entered by the start time.",
      "notJoinable": "This tournament is closed to new entries.",
      "roundsStarted": "The round has already started.",
      "ratingTooLow": "Your rating is below the minimum this tournament requires.",
      "wrongFormat": "Tournament format mismatch.",
      "privateTournament": "This tournament is private: you need the link or the password.",
      "wrongPassword": "Wrong password.",
      "tooManyAttempts": "Too many attempts. Try again in fifteen minutes.",
      "tournamentFull": "The tournament is full.",
      "alreadyHasLive": "You already have 3 live competitions: you can open another once one of them ends.",
      "nameTaken": "There is already a tournament with this name at that time.",
      "startTooSoon": "Too soon: leave at least five minutes to invite someone.",
      "startTooFar": "Too far ahead: two weeks from now at most.",
      "notOrganizer": "Only the organizer can do this.",
      "alreadyStarted": "The tournament has already started.",
      "tooLong": "The tournament would last more than a day: drop a few rounds or shorten the clock.",
      "cancelledByOrganizer": "The organizer cancelled this tournament.",
      "cancelledNoPlayers": "The tournament was cancelled: not enough players signed up.",
      "serverError": "Server error. Try again later.",
      "offline": "You look offline — check your connection.",
      "timeout": "The server did not answer. Try again.",
      "loadFailed": "Could not load the tournaments.",
      "notYourTurn": "It's not your turn.",
      "drawOfferFailed": "Could not offer a draw.",
      "unknown": "Something went wrong. Try again.",
      "moveRejected": "The server rejected your move: the board is back as it was.",
      "partitaSvanita": "The game is no longer on the server — it was most likely restarted. You're back in the tournament lobby.",
      "notInTournament": "You are not registered for this tournament.",
      "tournamentFullWayOut": "See other tournaments and arenas",
      "notPrivate": "This tournament is public: it has no keys to remake",
      "samePassword": "The new password is the same as the old one",
      "tournamentCancelled": "The tournament has been cancelled.",
      "inviteLinkExpired": "This invite link no longer works: join with the password."
    },
    "ended": {
      "title": "Tournament finished",
      "winner": "Winner",
      "noWinner": "No winner: no games were played.",
      "tiedWith": "Tied for first with {{players}}"
    },
    "share": {
      "title": "Draughts tournament",
      "text": "You are invited to the tournament {{nome}} on draughtsgame.com",
      "standingsTitle": "Final standings — {{nome}}"
    }
  },
  "chat": {
    "title": "Chat",
    "openChat": "Open chat",
    "closeChat": "Close chat",
    "empty": "No messages yet. Say hello!",
    "placeholder": "Type a message...",
    "unavailable": "Chat unavailable",
    "opponentLeft": "Your opponent has left the game.",
    "rateLimited": "You are typing too fast: wait a few seconds.",
    "closingIn": "Chat closes in {{seconds}}s",
    "closed": "This game's chat is closed.",
    "guestHint": "Guests can send quick reactions. Sign up for full chat.",
    "report": {
      "trigger": "Report",
      "title": "Report {{username}}",
      "intro": "Tell us what happened. A moderator will review this game's chat.",
      "quoteLabel": "Last message from {{username}}",
      "reasonLabel": "Reason",
      "reasons": {
        "insult": "Insults or offensive language",
        "harassment": "Harassment or threats",
        "hate_speech": "Hate speech or discrimination",
        "spam": "Spam or advertising",
        "other": "Something else"
      },
      "noteLabel": "Details (optional)",
      "notePlaceholder": "Anything that helps us understand",
      "privacyHint": "This game's chat (up to 100 messages, from both players) is saved for moderation and kept for {{days}} days.",
      "submit": "Send report",
      "sending": "Sending...",
      "done": "Report sent. Thank you.",
      "muted": "You reported this player. Their messages are hidden.",
      "errors": {
        "gone": "This game is over and its chat can no longer be verified. Please write to us from the Help page.",
        "duplicate": "You have already reported this player for this game.",
        "notReportable": "This opponent cannot be reported.",
        "notInGame": "You are not a player in this game.",
        "rateLimited": "Too many reports. Please try again later.",
        "generic": "Could not send the report. Please try again."
      }
    },
    "quickPhrases": "Quick phrases",
    "presets": {
      "hello": "Hello!",
      "goodLuck": "Have a good game!",
      "haveFun": "Have fun!",
      "goodGame": "Good game!",
      "untilNext": "See you next time!",
      "thanks": "Thanks!"
    }
  },
  "landing": {
    "nav": {
      "title": "Dama Online",
      "play": "Play",
      "tournaments": "Tournaments",
      "learn": "Learn",
      "community": "Community",
      "login": "Sign In"
    },
    "hero": {
      "badge": "The Ultimate Draughts Experience",
      "title": "Master the Art of Draughts",
      "subtitle": "Play against players worldwide, join tournaments, and improve your skills with our advanced training tools.",
      "playFree": "Play Now",
      "watchDemo": "Watch Demo"
    },
    "stats": {
      "players": "Active Players",
      "games": "Games Played",
      "variants": "Game Variants",
      "tournaments": "Daily Tournaments"
    },
    "features": {
      "title": "Why Choose Dama Online?",
      "subtitle": "Everything you need to become a draughts master",
      "variants": {
        "title": "Multiple Variants",
        "description": "Play Italian, International, English, and Brazilian draughts - all in one platform."
      },
      "matchmaking": {
        "title": "Smart Matchmaking",
        "description": "Our Glicko-2 rating system ensures fair and competitive matches every time."
      },
      "tournaments": {
        "title": "Arena Tournaments",
        "description": "Compete in daily tournaments with players from around the world."
      },
      "ai": {
        "title": "AI Training",
        "description": "Practice against our advanced AI with multiple difficulty levels."
      },
      "analysis": {
        "title": "Game Analysis",
        "description": "Review your games and learn from your mistakes with detailed analysis."
      },
      "community": {
        "title": "Active Community",
        "description": "Join clubs, chat with players, and make friends who share your passion."
      }
    },
    "variants": {
      "title": "Play Your Favorite Variant",
      "subtitle": "We support the most popular draughts variants from around the world",
      "pieces": "pieces",
      "italian": "Italian Draughts",
      "international": "International Draughts",
      "english": "English Draughts",
      "brazilian": "Brazilian Draughts"
    },
    "testimonials": {
      "1": {
        "name": "Marco B.",
        "role": "Tournament Player",
        "text": "The best draughts platform I've used. The matchmaking is fair and the tournaments are exciting!"
      },
      "2": {
        "name": "Elena V.",
        "role": "Casual Player",
        "text": "I love how easy it is to find a game. The interface is beautiful and intuitive."
      },
      "3": {
        "name": "Hans K.",
        "role": "Club Champion",
        "text": "Finally a platform that takes international draughts seriously. Highly recommended!"
      },
      "title": "What Players Say"
    },
    "cta": {
      "title": "Ready to Play?",
      "subtitle": "Join thousands of players and start your draughts journey today.",
      "button": "Start Playing Now"
    },
    "footer": {
      "tagline": "The premier online draughts platform",
      "game": "Game",
      "playNow": "Play Now",
      "tournaments": "Tournaments",
      "leaderboard": "Leaderboard",
      "puzzles": "Puzzles",
      "learn": "Learn",
      "tutorial": "Tutorial",
      "strategies": "Strategies",
      "rules": "Rules",
      "videos": "Videos",
      "community": "Community",
      "forum": "Forum",
      "clubs": "Clubs",
      "blog": "Blog",
      "discord": "Discord",
      "rights": "All rights reserved."
    }
  },
  "arena": {
    "title": "Arena",
    "subtitle": "Fast-paced continuous play",
    "ending": "Ending...",
    "status": {
      "live": "LIVE",
      "upcoming": "UPCOMING",
      "finished": "FINISHED"
    },
    "card": {
      "yourPlace": "you {{rank}}th"
    },
    "actions": {
      "join": "Join Arena",
      "leave": "Exit",
      "play": "Play",
      "pause": "Pause",
      "resume": "Resume",
      "boost": "Boost",
      "backToGame": "Back to the game",
      "retry": "Retry"
    },
    "errors": {
      "authRequired": "You must be signed in to take part in the arena.",
      "guestNotAllowed": "Guest accounts cannot join an arena. Create an account to keep your games.",
      "notAllowed": "This account cannot join an arena.",
      "arenaNotFound": "This arena no longer exists.",
      "userNotFound": "We could not find your account. Please sign in again.",
      "invalidInput": "The request was not valid. Reload the page and try again.",
      "rateLimited": "Too many attempts. Please wait a few seconds and try again.",
      "ratingTooLow": "Your rating is below the minimum this arena requires.",
      "joinFailed": "Could not sign you up for the arena. Please try again.",
      "arenaPiena": "This arena is full: there are no seats left.",
      "arenaChiusa": "This arena is no longer accepting entries.",
      "giaIscritto": "You are already in this arena.",
      "arenaScaduta": "This arena's time is up: we're only waiting for the last games to finish.",
      "arenaAnnullata": "This arena was cancelled.",
      "arenaAnnullataPochiIscritti": "This arena was cancelled: not enough players had entered by the start time.",
      "arenaAnnullataDaOrganizzatore": "Whoever opened this arena called it off.",
      "notOrganizer": "Only whoever opened this arena can do this.",
      "alreadyStarted": "The arena has already started.",
      "giaInUnArena": "You are already in a running arena: leave it to play in this one",
      "leaveFailed": "Could not take you out of the arena. Please try again.",
      "notInArena": "You are not signed up for this arena.",
      "notInGame": "You are not playing this game.",
      "gameNotFound": "This game no longer exists.",
      "tooLate": "Too late: the boost can only be changed before your first move.",
      "boostDisabled": "The boost is off in this arena.",
      "alreadyBoosted": "The boost is already on in this game.",
      "notBoosted": "The boost is not on in this game.",
      "boostFailed": "Could not turn the boost on. Please try again.",
      "unboostFailed": "Could not turn the boost off. Please try again.",
      "serverError": "Something went wrong on our side. Please try again.",
      "offline": "No connection to the server.",
      "timeout": "The server did not answer. Please try again.",
      "unknown": "Something went wrong. Please try again.",
      "notYourTurn": "It's not your turn.",
      "drawOfferFailed": "We couldn't send your draw offer. Try again.",
      "moveRejected": "The server rejected your move: the board is back as it was."
    },
    "standings": {
      "search": "Search a player",
      "searchEmpty": "No player with that name.",
      "sheetHint": "All games, latest on the right · gold = bonus",
      "loadMore": "Show more",
      "sheet": "Games",
      "toClimb_one": "{{count}} point to climb",
      "toClimb_other": "{{count}} points to climb",
      "lead_one": "{{count}} point ahead",
      "lead_other": "{{count}} points ahead",
      "boostOn": "boost active",
      "searchScope": "Search only looks at the rows already loaded: load the rest to search everyone.",
      "justPlayedHint": "The ↺ mark: you just played them — next to it is how long until they can come up again.",
      "justPlayedIn": "Already played: available again in {{time}}",
      "tiebreakOpp": "Opponents",
      "tiebreakOppTitle": "Average points of the opponents faced",
      "tiebreakH2hTitle": "Head-to-head among players on equal points: wins minus losses",
      "tiebreakHint": "On equal points: more wins, then the head-to-head, then stronger opponents, then fewer games played."
    },
    "info": {
      "details": "Details",
      "scoring": "Scoring System",
      "loss": "Loss: {{points}}",
      "boostTitle": "Boost ⚡",
      "boostTimeCost": "Removes your increment and halves your base time",
      "boostExtraPoint": "Doubles your victory points if you win",
      "boostBeforeFirst": "Can be switched on and off until your first move"
    },
    "matchFound": {
      "title": "Opponent Found",
      "opponent": "Opponent",
      "playAsWhite": "You play as White",
      "playAsBlack": "You play as Black",
      "startingIn": "Starting in",
      "startNow": "Start Now"
    },
    "gameEnd": {
      "win": "Victory",
      "loss": "Defeat",
      "draw": "Draw",
      "pointsEarned": "Points earned",
      "basePoints": "Base points",
      "boostBonus": "Boost bonus",
      "total": "Total",
      "pointsVoided": "Game not counted: no points awarded to either player",
      "rank": "Rank",
      "totalPoints": "Points",
      "paused": "You’re paused: resume whenever you like.",
      "arenaFinished": "Arena finished",
      "arenaDraining": "Time is up: the arena closes as soon as the last games end.",
      "analyze": "Analyze",
      "pause": "Paused",
      "playNext": "Continue",
      "backToArena": "Back to the arena",
      "resumeFailed": "We couldn't put you back in the queue: check your connection and try again.",
      "returnLegIn_one": "Return leg in {{count}} second…",
      "returnLegIn_other": "Return leg in {{count}} seconds…"
    },
    "game": {
      "boost": "Boost",
      "boostRemove": "Remove",
      "boostRetry": "Retry"
    },
    "confirmBoost": {
      "title": "Activate the boost?",
      "halve": "Your base time goes from {{prima}} to {{dopo}} and you lose the {{incremento}}s increment.",
      "halveOnly": "Your base time goes from {{prima}} to {{dopo}}.",
      "reward": "If you win, your points count double. You can remove it until your first move.",
      "confirm": "Activate"
    },
    "results": {
      "arenaFinished": "Arena Finished",
      "yourPosition": "Your position",
      "outOf_one": "out of {{count}} player",
      "outOf_other": "out of {{count}} players",
      "totalPoints": "Total points",
      "games": "games",
      "winRate": "Win rate",
      "share": "Share",
      "nextArena": "Next Arena",
      "unavailable": "We don't have this arena's results.",
      "unavailableSub": "Go back to the list and open it again from the \"Finished\" tab."
    },
    "tabs": {
      "rules": "Rules"
    },
    "signInToJoin": "Please sign in to join arenas",
    "positionCta": "Join and compete to climb the leaderboard!",
    "band": {
      "searchingTitle": "Looking for an opponent",
      "searchingSub": "I’ll take you into the game as soon as I find a pairing.",
      "drainingTitle": "Time is up",
      "drainingSub": "No more pairings: as soon as the last games end, the final standings go up.",
      "pausedTitle": "You’re paused",
      "pausedSub": "Nobody gets paired with you until you resume.",
      "pausedAwaySub": "I paused you because the app was in the background. Resume whenever you like.",
      "pausedOfflineSub": "I paused you because you were offline when the arena started.",
      "pausedOtherArenaSub": "You are playing in the other arena. When you are done there, press Resume to get back in the queue here.",
      "playingTitle": "You’re in a game",
      "playingSub": "The game is still open: go back to it.",
      "playingSubVs": "Against {{opponent}} · as {{color}}.",
      "waitingTitle": "You’re in",
      "waitingSub": "The arena hasn’t started yet.",
      "joinTitle": "You’re not in",
      "joinSub": "Join and I’ll pair you with whoever is queuing."
    },
    "timebar": {
      "endsIn": "Ends in"
    },
    "games": {
      "deletedPlayer": "Deleted player",
      "loadFailed": "We couldn't load the games."
    },
    "a11y": {
      "scoreUpdate": "Now {{points}} points, rank {{rank}}"
    },
    "spotlight": {
      "eyebrow": "Arena",
      "daysHours": "{{days}}d {{hours}}h",
      "startsIn": "Starts in",
      "yourResult": "You finished {{rank}}th",
      "review": "See how it went"
    },
    "twoLeg": "Two legs",
    "noBoost": "No boost",
    "share": {
      "title": "Draughts arena",
      "text": "You are invited to the arena {{nome}} on draughtsgame.com"
    },
    "detail": {
      "askPassword": "Arena password",
      "share": "Share invite",
      "shareCopied": "Link copied",
      "cancelArena": "Cancel arena",
      "cancelConfirm": "The arena disappears and everyone signed up is notified. This cannot be undone."
    }
  },
  "specialEvent": {
    "eyebrow": "Special event",
    "badge": "Special",
    "organizedBy": "Organized by Draughts Game"
  },
  "legal": {
    "termsTitle": "Terms",
    "privacyTitle": "Privacy",
    "acceptTerms": "I accept the <terms>Terms of Service</terms> and <privacy>Privacy Policy</privacy>",
    "acceptTermsOnly": "I accept the <terms>Terms of Service</terms>",
    "acceptPrivacyOnly": "I accept the <privacy>Privacy Policy</privacy>",
    "ageConfirm": "I confirm that I am at least 16 years old",
    "acceptRequired": "You must accept the Terms of Service",
    "acceptTermsRequired": "Tick this box to accept the Terms of Service",
    "acceptPrivacyRequired": "Tick this box to accept the Privacy Policy",
    "ageRequired": "Tick this box to confirm your age",
    "lastUpdated": "Last updated",
    "subtitle": "Your rights and our commitments",
    "missingConsents_one": "Still {{count}} box to tick above",
    "missingConsents_other": "Still {{count}} boxes to tick above"
  },
  "cookies": {
    "message": "We use essential cookies to make the site work. If you accept, we also use measurement tools — Umami, to see how the site is used, and Sentry, to catch errors. You can refuse: the site works just the same.",
    "acceptAll": "Accept all",
    "rejectAnalytics": "Essential only"
  },
  "puzzle": {
    "toPlayAndWin": "to play and win",
    "black": "Black",
    "white": "White",
    "dashboard": "Dashboard",
    "hint": "Hint",
    "hintTip": "A hint only costs you the rating: this puzzle becomes unrated, so you gain no points and lose none. It still counts as solved and keeps your Streak.",
    "solution": "Solution",
    "solutionTip": "Revealing the solution counts as a failed attempt: you lose rating points, but the day still counts towards your Streak.",
    "continueVsAI": "Keep playing vs AI",
    "playAgain": "Play again",
    "back": "Back",
    "forward": "Forward",
    "puzzleRating": "Puzzle rating",
    "ratingChange": "Rating",
    "newRating": "now",
    "yourRating": "Your rating",
    "solutionMoves": "Solution",
    "moves": "moves",
    "motifs": "Motifs",
    "motifsRevealed": "revealed",
    "motifsHidden": "revealed after solve",
    "result": {
      "solvedEyebrow": "Solved",
      "failedEyebrow": "Solution",
      "nice": "Nice",
      "solving": "solving.",
      "theLine": "Here is the",
      "line": "line."
    },
    "title": "Puzzles",
    "loading": "Loading puzzle...",
    "yourTurn": "Find the best move!",
    "correct": "Correct!",
    "incorrect": "Incorrect",
    "solved": "Puzzle solved!",
    "failed": "Puzzle failed",
    "giveUp": "Give up",
    "nextPuzzle": "Next puzzle",
    "backToHome": "Back to home",
    "rating": "Rating",
    "daily": "Daily Puzzle",
    "solve": "Solve",
    "demo": {
      "badge": "Demo puzzle",
      "solvedTitle": "Nice — solved!",
      "trainTitle": "Want to train every day?",
      "registerPitch": "Create a free account: a new puzzle every day, a different one for each variant.",
      "registerCta": "Create a free account"
    },
    "practice": "Practice",
    "share": "Share",
    "shareTitle": "Daily puzzle",
    "shareText": "I solved today’s daily puzzle — can you?",
    "shareCopied": "Link copied!",
    "retry": "Try again",
    "unavailable": {
      "title": "This puzzle isn’t available",
      "link": "We couldn’t open today’s puzzle. There may be no daily puzzle for this variant, or the connection dropped.",
      "session": "We couldn’t start this puzzle. Check your connection and try again.",
      "home": "Go to the home page"
    },
    "invite": {
      "title": "Today's daily puzzle is waiting for you",
      "body": "A friend shared today's daily puzzle with you. Daily puzzles are reserved for registered players — create a free account, or log in, to unlock the board.",
      "locked": "Preview locked",
      "tryDemo": "Try the demo puzzle meanwhile",
      "moves_one": "{{count}} move",
      "moves_other": "{{count}} moves"
    },
    "guest": {
      "locked": "Daily puzzles are for registered players. Sign in or create a free account to play them."
    },
    "networkError": "Network problem: the move was not recorded. Try again."
  },
  "dashboard": {
    "hero": {
      "welcome": "Welcome back",
      "settings": "Settings",
      "ctaPlayNow": "Play now",
      "ctaVsComputer": "Challenge AI",
      "moreVariants": "More variants ({{count}})",
      "logoutConfirmTitle": "Sign out?",
      "logoutConfirmBody": "You will be signed out of your account on this device.",
      "ctaDailyPuzzle": "Daily puzzles",
      "themeDark": "Switch to dark theme",
      "themeLight": "Switch to light theme",
      "doNotDisturbOn": "Do not disturb",
      "doNotDisturbOff": "Become available again",
      "doNotDisturbBadge": "Busy",
      "doNotDisturbTurnOff": "Turn off",
      "ratingDeltaUp": "Up {{points}} over the last 7 days",
      "ratingDeltaDown": "Down {{points}} over the last 7 days"
    },
    "notif": {
      "challengedYou": "<b>{{name}}</b> ({{rating}}) challenged you to <b>{{timeControl}}</b> · {{variant}}",
      "challengedYouNoRating": "<b>{{name}}</b> challenged you to <b>{{timeControl}}</b> · {{variant}}",
      "accept": "Accept",
      "decline": "Decline"
    },
    "streak": {
      "daysInRow_one": "{{count}} day in a row",
      "daysInRow_other": "{{count}} days in a row",
      "unitLabel_one": "day in a row",
      "unitLabel_other": "days in a row",
      "record": "Record to beat: <b>{{count}} days</b>",
      "recordTying": "Record tied: <b>{{count}} days</b>",
      "empty": "Start today",
      "solvePuzzle": "Solve a puzzle",
      "doneToday": "Done for today 🔥",
      "keepHint": "Play or solve a puzzle to keep your streak.",
      "last7DaysLabel": "Last 7 days activity",
      "festa": {
        "subtitle": "Come back tomorrow to extend it"
      }
    },
    "dailyGoal": {
      "title": "Daily goal",
      "label": "Games",
      "remaining_one": "<b>One more</b> to complete the goal",
      "remaining_other": "<b>{{count}} more</b> to complete the goal",
      "done": "Goal completed",
      "targetLabel": "Games per day",
      "editGoal": "Edit daily goal",
      "festa": {
        "subtitle": "Today's goal complete"
      }
    },
    "festa": {
      "dismiss": "Tap to close"
    },
    "activity": {
      "title": "Activity",
      "last3Months": "Last 3 months",
      "centerGames": "games",
      "statsGames_one": "{{count}} game",
      "statsGames_other": "{{count}} games",
      "statsActiveDays_one": "{{count}} active day",
      "statsActiveDays_other": "{{count}} active days",
      "statsPerDay": "{{value}} games/day",
      "empty": "Your games will appear here",
      "statsTotalTime": "{{value}} total",
      "tooltipToday": "Today",
      "tooltipYesterday": "Yesterday",
      "legendBucket0": "0",
      "legendBucket1": "1-2",
      "legendBucket2": "3-5",
      "legendBucket3": "6-9",
      "legendBucket4": "10+",
      "duration": {
        "zero": "0 min",
        "minutes_one": "{{count}} min",
        "minutes_other": "{{count}} min",
        "hours_one": "{{count}}h",
        "hours_other": "{{count}}h",
        "hoursMinutes": "{{hours}}h {{minutes}}m"
      },
      "dayMon": "Mon",
      "dayThu": "Thu",
      "daySat": "Sat",
      "dayTue": "Tue",
      "dayWed": "Wed",
      "dayFri": "Fri",
      "daySun": "Sun"
    },
    "recentGames": {
      "title": "Recent games",
      "viewAll": "View all in profile →",
      "replay": "Replay",
      "empty": "No games yet"
    },
    "upcomingTournaments": {
      "title": "Active tournaments",
      "viewAll": "See all →",
      "viewAllAria": "See all tournaments",
      "empty": "No tournaments scheduled"
    },
    "liveEvent": {
      "emptyTitle": "Tournaments & Arenas",
      "empty": "No live events right now",
      "nextAt": "Next Daily starts at {{time}}",
      "minutesLeft_one": "Ends in {{count}} minute",
      "minutesLeft_other": "Ends in {{count}} minutes",
      "participants_one": "{{count}} player",
      "participants_other": "{{count}} players"
    },
    "puzzle": {
      "titleWhiteToMove": "White to move\nand win",
      "titleBlackToMove": "Black to move\nand win",
      "meta": "Find the best sequence",
      "cta": "Solve →",
      "viewAll": "All →",
      "tag": {
        "tactic": "Tactics"
      },
      "solvedNext": "Solved ✓ · Come back tomorrow for the next one",
      "tryInternational": "Try an International puzzle →",
      "overlayTitle": "Daily puzzles"
    },
    "avvisoDati": {
      "offline": "You seem to be offline — your data did not load.",
      "server": "Couldn't load your data.",
      "inCorso": "Retrying…",
      "ricarica": "Reload"
    },
    "installCard": {
      "eyebrow": "App",
      "title": "Install Draughts Game",
      "benefit": "Add it to your Home screen: it opens full screen, starts faster and sits next to your other apps.",
      "howTo": "How does it work?",
      "choose": "Choose your device:",
      "os": {
        "android": "Android",
        "ios": "iPhone or iPad",
        "desktop": "Computer"
      }
    }
  },
  "pwa": {
    "openInAppText": "You're inside WhatsApp's browser. Open this link outside it to use the app properly.",
    "openInAppCta": "Open in the app",
    "openInBrowserText": "You're inside WhatsApp's browser. Open this link in Safari for the full experience.",
    "iosHint": "Tap ••• at the bottom right, then “Open in Safari”.",
    "installText": "Install Draughts Game to play from your home screen.",
    "installCta": "Install the app",
    "copyLink": "Copy link",
    "linkCopied": "Link copied!",
    "dismiss": "Dismiss"
  },
  "seo": {
    "breadcrumbHome": "Home",
    "landing": {
      "title": "Draughts Game — play draughts online free",
      "description": "Play draughts online free: International, Italian, Turkish, Frisian and 20 more variants. Real-time multiplayer, rated games, tournaments, AI opponents and a daily puzzle."
    },
    "faq": {
      "title": "FAQ — questions about playing draughts online",
      "description": "Answers about accounts, ratings, tournaments, installing the app and playing draughts online, plus a direct channel for issues and feedback."
    },
    "terms": {
      "title": "Terms of Service — Draughts Game",
      "description": "The terms that govern the use of Draughts Game: accounts, fair play, ratings, content and the rules both sides agree to."
    },
    "privacy": {
      "title": "Privacy Policy — Draughts Game",
      "description": "What data Draughts Game collects, why, how long it is kept and the rights you have over it under the GDPR."
    }
  }
}
